import {message, Modal, notification, Typography} from 'antd';
import {FirebaseHelper, FirestoreHelper} from "./firebase-helper";
import ROUTES from "./routes";
import {ApiBaseHelper, BASE_URL} from "./api-base-helper";
import {updateAdmin, updateTech, updateTechReserve, updateUser} from "../redux/reducers/app";
import CryptoJS from 'crypto-js';
import moment from "moment";
// import {encode} from 'html-entities';
import {ACCEPTANCE_SERVER, DEV_SERVER, LOCAL_SERVER, MINIMUM_NUMBER_OF_TECHS, PROD_SERVER, STAGING_SERVER} from "./constants";
import history from './history';
// import citiesStatesWithLngLat from "./cities-states-with-lng-lat.json"
import citiesStatesWithLngLatMin from "./cities-states-with-lng-lat-min.json"
import { STATES, MATCHED_CITIES_STATES } from './us-states-city';
import { ManagerRouteBlacklist, RecruiterRouteBlacklist } from './route-blacklist';
import MasterCardSvg from "../assets/images/master-card.svg";
import VisaSvg from "../assets/images/visa.svg";
import UnionPaySvg from "../assets/images/union-pay.svg";
import JcbSvg from "../assets/images/jcb.svg";
import DiscoverSvg from "../assets/images/discover.svg";
import DinersClubSvg from "../assets/images/diners-club.svg";
import AmericanExpressSvg from "../assets/images/american-express.svg";
import { RtmRepository } from '../views/pages/common/private/real-time-messaging/repository/rtm-repository';
import { AggregateQuerySnapshot } from 'firebase/firestore';
import JiraIcon from '../assets/images/jira-icon.svg';
import AsanaIcon from '../assets/images/asana-icon.svg';
import TrelloIcon from '../assets/images/trello-icon.svg';
import ClickupIcon from '../assets/images/clickup-icon.svg';
import NotionIcon from '../assets/images/notion-icon.svg';
import GenericIcon from '../assets/images/generic-icon.svg';

// helper functions

export const nameFormat = (name) => {
    if(!name) return ""
    if (!name.includes(" ")) {
        return name
    }
    let splitName = name.split(" ")
    return splitName[0] + " " + splitName[1][0] + "."
}

export const altNameFormat = (name) => {
    if(!name) return ""
    if (!name.includes(" ")) {
        return name
    }
    let splitName = name.split(" ")
    return splitName[1][0]?.toUpperCase() + ". " + capitalizeFirstLetter(splitName[0]?.toLowerCase()) 
}

export const DEFAULT_DEVICE_TYPES = [
    {
        "Id": "a1W55000001Y3oLEAS",
        "Group_Name": "Desktop",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001Y3oLEAS-php1nhUcI_x_y.png",
        "Category_Id": 1,
        "Operating_System": [
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-windows_os.png",
                "Name": "Windows"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpK2zkT7_x_y.png",
                "Name": "macOS"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpE8OWs7_x_y.png",
                "Name": "Chromebook"
            }
        ]
    },
    {
        "Id": "a1W55000001WZoIEAW",
        "Group_Name": "Tablet",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001WZoIEAW-phpIDWMQH_x_y.png",
        "Category_Id": 2,
        "Operating_System": [
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpaSijkC_x_y.png",
                "Name": "iOS"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-php7xyud7_x_y.webp",
                "Name": "Android"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpE8OWs7_x_y.png",
                "Name": "Chromebook"
            }
        ]
    },
    {
        "Id": "a1W55000001WZoDEAW",
        "Group_Name": "Phone",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001WZoDEAW-phpyC0jqf_x_y.png",
        "Category_Id": 3,
        "Operating_System": [
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpaSijkC_x_y.png",
                "Name": "iOS"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-php7xyud7_x_y.webp",
                "Name": "Android"
            }
        ]
    },
    {
        "Id": "a1W55000001WZo3EAG",
        "Group_Name": "TV",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001WZo3EAG-phpEuncfC_x_y.png",
        "Category_Id": 4,
        "Operating_System": null
    },
    {
        "Id": "a1W55000001WZoNEAW",
        "Group_Name": "Accessory",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001WZoNEAW-phpnfc95O_x_y.png",
        "Category_Id": 5,
        "Operating_System": null
    },
    {
        "Id": "a1W55000001WZntEAG",
        "Group_Name": "Laptop",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001WZntEAG-phpTA9wtN_x_y.png",
        "Category_Id": 6,
        "Operating_System": [
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-windows_os.png",
                "Name": "Windows"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpK2zkT7_x_y.png",
                "Name": "macOS"
            },
            {
                "Picture": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a0C55000003lo95EAA-phpE8OWs7_x_y.png",
                "Name": "Chromebook"
            }
        ]
    },
    {
        "Id": "a1W55000001WZnyEAG",
        "Group_Name": "Wifi",
        "Pic": "https://s3-us-west-2.amazonaws.com/hipaadev/uploaded/a1W55000001WZnyEAG-phpUZBA4P_x_y.png",
        "Category_Id": 7,
        "Operating_System": null
    }
];
export const SERVICE_IMAGE_LIBRARY = [
    {
        title: "Mobile Phones",
        images: [
            {
                uid: 'mobile-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1612442443556-09b5b309e637?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YW5kcm9pZCUyMHBob25lfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1480694313141-fce5e697ee25?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8c21hcnRwaG9uZXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1603921326210-6edd2d60ca68?ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8c2Ftc3VuZyUyMHBob25lfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1556656793-08538906a9f8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aXBob25lfGVufDB8MHwwfHw%3D&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1512499617640-c74ae3a79d37?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8aXBob25lfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1519923834699-ef0b7cde4712?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8aXBob25lfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8c2Ftc3VuZyUyMHBob25lfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },
            {
                uid: 'mobile-8',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1568378711447-f5eef04d85b5?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fHNhbXN1bmclMjBwaG9uZXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
            },


        ]
    },
    {
        title: "Laptop",
        images: [
            {
                uid: 'Laptop-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1593642702909-dec73df255d7?fit=crop&w=450&q=80',
            },
            {
                uid: 'Laptop-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1516387938699-a93567ec168e?fit=crop&w=450&q=80',
            },
            {
                uid: 'Laptop-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1603302576837-37561b2e2302?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fGxhcHRvcHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Laptop-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1559163499-413811fb2344?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTl8fGxhcHRvcHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Laptop-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1485988412941-77a35537dae4?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzF8fGxhcHRvcHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Laptop-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1511385348-a52b4a160dc2?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzR8fGxhcHRvcHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Laptop-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1602080858428-57174f9431cf?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fGxhcHRvcHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },

        ]
    },
    {
        title: "Desktop",
        images: [
            {
                uid: 'Desktop-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1542435503-956c469947f6?fit=crop&w=450&q=80',
            },
            {
                uid: 'Desktop-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1529336953128-a85760f58cb5?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8ZGVza3RvcHxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Desktop-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1594400344473-cf8b48733c1f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjF8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Desktop-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1614624532983-4ce03382d63d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjZ8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Desktop-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1593640495390-1ff7c3f60e9b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjN8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Desktop-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1493723843671-1d655e66ac1c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjV8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Desktop-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1593300806914-e1884ba37524?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Desktop-8',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDR8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },

        ]
    },
    {
        title: "Televisions",
        images: [
            {
                uid: 'TV-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dHZ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'TV-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1461151304267-38535e780c79?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dGVsZXZpc2lvbnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'TV-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1586024486164-ce9b3d87e09f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8dGVsZXZpc2lvbnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'TV-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8dGVsZXZpc2lvbnxlbnwwfDB8MHx8&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'TV-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1601944177325-f8867652837f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fHRlbGV2aXNpb258ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'TV-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1593078165899-c7d2ac0d6aea?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjJ8fHRlbGV2aXNpb258ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'TV-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1601944179066-29786cb9d32a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjR8fHRlbGV2aXNpb258ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },

        ],
    },
    {
        title: "Printers",
        images: [
            {
                uid: 'Printer-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cHJpbnRlcnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Printer-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1625961332771-3f40b0e2bdcf?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8cHJpbnRlcnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Printer-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1551781069-73a1da89e333?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8cHJpbnRlcnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Printer-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1571845995697-28be270350de?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8cHJpbnRlcnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Printer-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1523120974498-9d764390d8e5?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fHByaW50ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Printer-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1630327722923-5ebd594ddda9?ixid=MnwxMjA3fDB8MHxzZWFyY2h8ODN8fHByaW50ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },


        ],
    },
    {
        title: "Home Theaters",
        images: [
            {
                uid: 'Theater-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1596793503406-d90c450ba1b1?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8aG9tZSUyMHRoZWF0ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Theater-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/flagged/photo-1572609239482-d3a83f976aa0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aG9tZSUyMHRoZWF0ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Theater-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1540407473297-b9c7ef744e1a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8aG9tZSUyMHRoZWF0ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Theater-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://www.lifewire.com/thmb/ndpZEPjdTCLntZQwkBPH4eZ4oKs=/3865x2577/filters:no_upscale():max_bytes(150000):strip_icc()/movie-playing-on-projection-screen-in-home-theater-915093896-5bdb7eb0c9e77c0026d2970f-52f2860826054782a4fc48b588e441fe.jpg',
            },
            {
                uid: 'Theater-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://avidiaonline.com/images/easyblog_articles/18/4-Steps-to-Designing-the-Ultimate-Home-Theater-System_69d101d0e9184e3897dd4c23a1c89d1e.jpg',
            },
            {
                uid: 'Theater-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1532621623813-d37d9cd1d992?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8aG9tZSUyMHRoZWF0ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Theater-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1589113050289-1c654e7e305d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aG9tZSUyMGNpbmVtYXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Theater-8',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y2luZW1hfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
        ],
    },
    {
        title: "Consoles",
        images: [
            {
                uid: 'Console-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1605901309584-818e25960a8f?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Y29uc29sZXN8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Console-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1550921464-9f7a27f99edc?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Y29uc29sZXN8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Console-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1531594896955-305cf81269f1?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTN8fGNvbnNvbGVzfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Console-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1507457379470-08b800bebc67?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cGxheXN0YXRpb258ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Console-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1606144042614-b2417e99c4e3?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cGxheXN0YXRpb258ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Console-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1614294148960-9aa740632a87?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8eGJveHxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'Console-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1603565913235-382c62d3b2ee?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fHhib3h8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },

        ],
    },
    {
        title: "Wifi",
        images: [
            {
                uid: 'wifi-1',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1516044734145-07ca8eef8731?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'wifi-2',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1603731955926-81917dad5a80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'wifi-3',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1606904825846-647eb07f5be2?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'wifi-4',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1554098415-cae1af5e4f1a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'wifi-5',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1606421753414-8d165c9d48e5?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjF8fHdpZml8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'wifi-6',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1554098415-4052459dc340?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzN8fHdpZml8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },
            {
                uid: 'wifi-7',
                percent: 100,
                name: 'image.png',
                status: 'done',
                url: 'https://images.unsplash.com/photo-1603899123005-4b772bef4f09?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
            },

        ],
    },


    // {
    //     uid: 'mobile-',
    //     percent: 100,
    //     name: 'image.png',
    //     status: 'done',
    //     url:'VALUEE'
    // },

];
export const SERVICES_SUGGESTIONS = [
    {
        title: "Comprehensive Network Security Audit & Hardening",
        description: "Your dedicated security engineer systematically fortifies every layer of your network stack, delivering a turnkey remediation roadmap.",
        deliverables: [
          "Kick-off call to define scope, data-flow diagrams, compliance goals",
          "Deploy passive scanners to inventory on-prem & cloud assets",
          "Collect switch, router, AP, firewall configs for baseline diffing",
          "Run credentialed vulnerability scans across all subnets",
          "Evaluate patch levels, firmware versions, end-of-life hardware",
          "Map open ports/services to business owners & justify exposure",
          "Test segmentation, VLAN tagging, ACL consistency, zero-trust posture",
          "Inspect wireless encryption, rogue SSID detection, guest-net isolation",
          "Verify MFA enforcement, password rotation, privileged account hygiene",
          "Review logging coverage, retention, and SIEM ingestion parsers",
          "Produce risk-weighted findings matrix with CVSS scores & quick wins",
          "Harden configs: disable legacy ciphers, enforce secure protocols",
          "Draft 90-day remediation schedule aligned to operations windows",
          "Present executive summary & technical appendix to stakeholders",
          "Optional retest to confirm risk reduction & continuous monitoring hand-off"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "Audit", "Network"]
    },
    {
        title: "Proactive Patch Management & Vulnerability Remediation",
        description: "Sleep easy knowing every server, endpoint, and IoT device is patched on schedule—without disrupting productivity.",
        deliverables: [
          "Establish maintenance windows & rollback strategy with stakeholders",
          "Deploy lightweight agent for asset discovery & patch compliance stats",
          "Map devices to vendor advisories; classify severity & exploitability",
          "Stage patches in sandbox; test business-critical workflows for regressions",
          "Automate phased rollout by device group, geography, or criticality",
          "Verify installation logs, firmware flashes, and configuration drift",
          "Remediate failed installs & document root causes",
          "Update gold images & baseline templates to prevent regression",
          "Generate compliance dashboard & monthly executive scorecards",
          "Coordinate emergency out-of-band patching for zero-day threats",
          "Decommission superseded patches to reclaim storage & bandwidth",
          "Conduct quarterly vulnerability scans to validate effectiveness",
          "Share best-practice recommendations to tighten patch cadence",
          "Provide SLA-bound support desk for patch-related incidents",
          "Continuous improvement loop feeds lessons into future patch cycles"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "Patching", "Remediation"]
    },
    {
        title: "24 x 7 Managed Endpoint Detection & Response (EDR)",
        description: "Our SOC analysts watch your fleet around the clock, stopping threats before damage occurs.",
        deliverables: [
          "Select & deploy best-fit EDR agent for OS mix and budget",
          "Tune behavioral & signature-based policies to cut false positives",
          "Integrate EDR telemetry into SIEM for unified visibility",
          "Configure real-time alerting channels (Slack/Teams/SMS/email)",
          "Establish incident-severity matrix & on-call escalation tree",
          "Hunt for lateral-movement indicators, privilege abuse, rootkits",
          "Contain compromised hosts via network isolation or process kill",
          "Pull forensic triage (memory dump, file hashes, timeline)",
          "Eradicate malware, backdoors, persistence mechanisms",
          "Patch exploited vulnerabilities & reset credentials post-containment",
          "Generate post-incident report with MITRE ATT&CK mapping",
          "Conduct monthly threat-intel briefings & playbook refinements",
          "Provide executive KPI dashboard (MTTD, MTTR, dwell time)",
          "Continuous tuning to adapt to new TTPs & business changes",
          "Optional purple-team exercises to validate detection coverage"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "EDR", "Monitoring"]
    },
    {
        title: "Secure Cloud Migration & Optimization",
        description: "Move to AWS, Azure, or GCP with confidence—secure, performant, and cost-tuned from day one.",
        deliverables: [
          "Inventory on-prem workloads & map to cloud service equivalents",
          "Build TCO model covering compute, storage, data-egress, support",
          "Draft landing-zone architecture with network, IAM, logging guardrails",
          "Design CIS-aligned policies, tagging standards, and automated enforcement",
          "Plan phased migration waves based on dependency graph & risk appetite",
          "Provision infrastructure-as-code templates (Terraform/CloudFormation)",
          "Encrypt data at rest & in transit; configure KMS & key rotation",
          "Implement least-privilege roles, SSO federation, conditional access",
          "Validate performance baselines; right-size instances & autoscaling rules",
          "Establish backup, replication, and multi-AZ resilience strategies",
          "Cutover execution with rollback scripts & stakeholder comms plan",
          "Post-migration security scanning & performance tuning",
          "Activate cost-optimization reports & anomaly budgets",
          "Knowledge-transfer session with ops team & runbooks hand-off",
          "Ongoing managed optimization & patching optional add-on"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: null,
        tags: ["Cloud", "Migration", "Optimization"]
    },
    {
        title: "Business Continuity & Disaster Recovery Planning",
        description: "Guarantee uptime with an actionable BC/DR plan aligned to your RTO/RPO targets.",
        deliverables: [
          "Conduct business-impact analysis to rank critical processes",
          "Identify single-points of failure across infra, apps, people, vendors",
          "Define RTO/RPO metrics & acceptable downtime per service",
          "Map data protection strategy (backup, replication, snapshots)",
          "Architect failover environment (multi-site, cloud DR, cold standby)",
          "Draft communication tree for incident declaration & status updates",
          "Develop DR runbook with step-by-step recovery procedures",
          "Automate health checks & replication audits",
          "Schedule tabletop exercises & full DR failover tests",
          "Capture lessons learned & refine documentation",
          "Align plan with regulatory mandates (HIPAA, SOC 2, ISO 27001)",
          "Provide training to department heads on roles & responsibilities",
          "Integrate BC/DR metrics into executive dashboard",
          "Offer optional 24/7 recovery support SLA",
          "Annual reassessment to account for business and tech changes"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: null,
        tags: ["Continuity", "Disaster Recovery", "Planning"]
    },
    {
        title: "Identity & Access Management (IAM) Roll-out",
        description: "Lock down privileges and simplify logins with a modern, unified IAM stack.",
        deliverables: [
          "Audit current directories, privilege assignments & shadow IT",
          "Select best-fit IAM/IDaaS platform (Okta, Entra ID, JumpCloud, etc.)",
          "Map users, groups, roles, and entitlements to least-privilege model",
          "Implement MFA, conditional access, and adaptive risk policies",
          "Integrate SAML/OIDC SSO across SaaS apps & legacy systems",
          "Migrate credentials, provision SCIM automation & JIT access",
          "Configure privileged access workflow & break-glass accounts",
          "Establish lifecycle hooks for onboarding, transfers, offboarding",
          "Enable auditing, alerting, and anomaly detection feeds",
          "Provide end-user comms & self-service password reset portal",
          "Conduct access-review campaigns & certify compliance",
          "Document IAM governance policy & incident response playbook",
          "Train IT staff on tool administration & reporting",
          "Cut legacy LDAP/AD dependencies where feasible",
          "Continuous review to adapt to org growth & M&A activity"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "IAM", "Access Control"]
      },
      {
        title: "Secure Email Gateway & Phishing Defense",
        description: "Stop phishing, spoofing, and ransomware at the inbox edge.",
        deliverables: [
          "Baseline current email flow, relay paths, and SPF/DKIM/DMARC status",
          "Deploy secure email gateway or cloud API-based filter",
          "Configure anti-spam, anti-virus, sandboxed link & attachment analysis",
          "Implement impersonation protection & VIP name checks",
          "Enforce outbound DLP policies & encryption triggers",
          "Roll out user-reported phishing button with SOC integration",
          "Conduct spear-phishing simulation campaign to benchmark risk",
          "Deliver role-based security awareness training modules",
          "Tune filter policies to balance security and business flow",
          "Generate monthly click-rate & risk-scorecard reports",
          "Integrate gateway logs into SIEM for cross-correlation",
          "Provide executive briefings on threat trends & user susceptibility",
          "Enable auto-remediation of delivered malicious emails",
          "Document escalation workflow for suspected phishing incidents",
          "Optional continuous simulation subscription for culture reinforcement"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: null,
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "Email", "Phishing"]
      },
      {
        title: "Compliance Readiness & Gap Analysis (HIPAA, PCI-DSS, GDPR)",
        description: "Navigate complex regulations with a structured roadmap and evidence binder.",
        deliverables: [
          "Identify in-scope systems, data flows, and third-party processors",
          "Map current controls to regulatory framework requirements",
          "Interview process owners; collect SOPs, policies, and audit logs",
          "Conduct technical scans for encryption, logging, and data segregation",
          "Score each requirement: compliant, partial, non-compliant",
          "Present gap matrix with remediation effort & risk impact",
          "Draft prioritized action plan and budget estimates",
          "Provide policy templates & awareness-training material",
          "Assist with control implementation and evidence collection",
          "Facilitate penetration test & vulnerability scan scheduling",
          "Assemble auditor-ready evidence binder & control narratives",
          "Conduct mock audit interviews with key personnel",
          "Track remediation progress in compliance management portal",
          "Produce executive summary with board-level KPIs",
          "Optional ongoing vCISO oversight & annual surveillance audits"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: "compliance.jpg",
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Compliance", "Security", "Audit"]
      },
      {
        title: "SIEM Deployment & Log Monitoring",
        description: "Centralize logs, detect threats sooner, and meet audit mandates.",
        deliverables: [
            "Define log-sources, retention requirements, and compliance scope",
            "Select SIEM platform (Splunk, LogScale, Sentinel, etc.) & sizing",
            "Build ingestion pipelines, parsers, normalization rules",
            "Configure time-sync (NTP) & secure log transport (TLS/syslog-TLS)",
            "Develop correlation searches & alert thresholds aligned to MITRE ATT&CK",
            "Integrate threat-intel feeds and enrichment services",
            "Implement dashboards for SOC, DevOps, and Exec audiences",
            "Tune noise vs. fidelity; establish suppression rules for known benign events",
            "Configure long-term cold storage & searchable archive tier",
            "Train IT staff on search, pivot, and incident workflow",
            "Validate detection coverage via red-team log-artifact injection",
            "Document log-source onboarding playbook",
            "Automate ticket creation & escalation via ITSM API",
            "Provide monthly health check & performance optimization",
            "Optional 24/7 managed SOC add-on"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: null,
        tags: ["SIEM", "Logging", "Monitoring"]
      },
      {
        title: "Remote Helpdesk & IT Support SLA",
        description: "Scalable Tier 1–Tier 3 support that feels in-house—only smarter and cheaper.",
        deliverables: [
            "Define ticket categories, priorities, SLAs, and escalation matrix",
            "Deploy remote-monitoring & management (RMM) agent fleet-wide",
            "Stand up branded self-service portal and knowledge base",
            "Provide 24/7 multichannel intake (phone, chat, email, portal)",
            "Resolve Tier 1 issues via scripted runbooks & automation",
            "Escalate complex cases to specialized Tier 2/3 technicians",
            "Perform proactive health checks & threshold alerts",
            "Patch, AV, backup status integrated into ticket triggers",
            "Conduct monthly service-review meeting & trend analysis",
            "Continuous improvement of KB articles and automated fixes",
            "CSAT surveys tied to technician performance incentives",
            "Optional on-site dispatch coordination for hardware swaps",
            "Asset & warranty tracking integrated with CMDB",
            "Quarterly roadmap recommendations for infrastructure upgrades",
            "Full data-export access for transparency"
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: null,
        tags: ["Helpdesk", "Support", "SLA"]
    },
    {
        title: "Wireless Infrastructure Assessment & Deployment",
        description: "Deliver campus-wide Wi-Fi that is fast, secure, and interference-free.",
        deliverables: [
            "Site survey (Ekahau/NetSpot) to capture signal heatmaps & RF noise",
            "Analyze density requirements, roaming behavior, and IoT segregation",
            "Design AP placement, channel plan, and transmit power levels",
            "Specify hardware (Wi-Fi 6E/7, controller vs. cloud-managed)",
            "Prestage & firmware update all APs and controllers",
            "Implement 802.1X, WPA3-Enterprise, and dynamic VLAN assignment",
            "Configure guest captive portal, rate-limits, and splash branding",
            "Seamless handoff tuning for VoIP and real-time traffic",
            "Post-deployment validation survey & performance benchmarks",
            "Document floor-plan with AP labels and controller settings",
            "Train IT staff on monitoring dashboard & alert rules",
            "Provide 90-day hyper-care with on-demand tuning",
            "Optional subscription for ongoing RF monitoring & optimization",
            "Periodic firmware / feature enhancement rollout",
            "Decommission legacy APs & reclaim spectrum"
        ],
        location: "on_site",
        deviceTypes: "network",
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: null,
        tags: ["Networking", "Wi-Fi", "Infrastructure"]
    },
    {
        title: "Server Virtualization & Capacity Planning",
        description: "Consolidate workloads, cut costs, and gain agility with expertly tuned virtualization.",
        deliverables: [
            "Audit physical servers, CPU/RAM/storage usage, and licensing footprint",
            "Design target hypervisor architecture (VMware, Hyper-V, Proxmox, etc.)",
            "Build capacity model with 20% headroom for bursts & HA",
            "Configure clusters, vSwitches, DRS, HA, and SR-IOV as applicable",
            "Migrate physical/legacy VMs with minimal downtime (P2V/V2V)",
            "Implement SAN/NAS or hyper-converged storage with deduplication",
            "Enable backup/replication using CBT and granular restore",
            "Harden hypervisor management planes; role-based access & MFA",
            "Optimize resource reservations, NUMA node alignment, and IO queues",
            "Establish performance & capacity dashboards with alert thresholds",
            "Document VM deployment standards & golden image maintenance",
            "Train ops on snapshot etiquette and disaster-recovery drills",
            "Periodic rightsizing reports & license optimization suggestions",
            "Optional managed operations for patching and lifecycle refresh",
            "Annual capacity plan refresh aligned to business growth"
        ],
        location: "on_site",
        deviceTypes: "server",
        active: false,
        price: null,
        usageType: "Metered",
        image: null,
        file: null,
        tags: ["Virtualization", "Infrastructure", "Servers"]
    },
    {
        title: "Data Backup Strategy Implementation & Monitoring",
        description: "Because data loss is not an option.",
        deliverables: [
            "Identify critical data sets, recovery objectives, and compliance duties",
            "Evaluate 3-2-1 strategy fit (on-site, off-site, cloud copy)",
            "Select backup software & storage tier (immutable object, tape, etc.)",
            "Configure schedules, retention, encryption, and network throttling",
            "Seed full backups; run incremental-forever or synthetic-full cadence",
            "Verify backups via automated SureBackup/restore tests",
            "Set up job health alerts in email, Slack, or ITSM tickets",
            "Perform quarterly restore drills for key systems",
            "Harden backup repository against ransomware (air-gap, MFA)",
            "Document restore playbooks with RTO expectations",
            "Provide dashboard with success rate, capacity trends, dedupe ratio",
            "Review backup windows against growth; adjust storage tiers",
            "Offer optional DRaaS spin-up in cloud for failover",
            "Train staff on self-service granular file restores",
            "Annual strategy refresh incorporating new workloads & tech"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "server, cloud",
        active: false,
        price: null,
        image: null,
        file: null,
        tags: ["Backup", "Data Protection", "Disaster Recovery"]
    },
    {
        title: "Firewall Configuration & Zero-Trust Segmentation",
        description: "Stop flat networks in their tracks and gain granular control.",
        deliverables: [
            "Inventory current firewall rules, objects, and change history",
            "Map business applications to required ports/protocols",
            "Design zero-trust segments by sensitivity and east-west traffic flows",
            "Deploy next-gen firewalls or micro-segmentation agents",
            "Enable IPS, anti-malware, geo-IP filtering, and TLS inspection",
            "Clean up legacy 'allow any' rules; implement change-control tags",
            "Configure HA pairs, VRRP, and automatic failover checking",
            "Integrate firewall logs with SIEM & SOAR for auto-response",
            "Test segmentation with simulated attacks & path-trace tools",
            "Document policy matrix & justified exceptions",
            "Train ops on rule-lifecycle process and automation scripts",
            "Quarterly rule-recertification campaign with app owners",
            "Provide executive heat-map of risky firewall policies",
            "Optional managed firewall service with 24/7 monitoring",
            "Continuous policy optimization to reduce attack surface"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "network, firewall",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "Firewall", "Zero Trust"]
    },
    {
        title: "Mobile Device Management & BYOD Governance",
        description: "Secure mobility without sacrificing user experience.",
        deliverables: [
            "Catalog corporate-owned & BYOD endpoints; tag risk categories",
            "Select MDM/UEM platform (Intune, Kandji, Jamf, etc.)",
            "Enroll devices with zero-touch or DEP/Android-Enterprise workflows",
            "Apply configuration profiles (Wi-Fi, VPN, certificates) automatically",
            "Enforce device health checks, passcode, encryption, jailbreak/root detection",
            "Configure containerized work apps & managed app protection policies",
            "Push corporate app catalog & version control",
            "Enable remote wipe, lock, or selective wipe on separation",
            "Monitor compliance dashboards & remediate drift",
            "Provide self-service portal for privacy transparency & opt-out",
            "Draft BYOD policy and end-user communications",
            "Integrate device posture into conditional access policies",
            "Quarterly review of device fleet and OS end-of-life status",
            "Optional kiosk-mode configuration for frontline devices",
            "Retire decommissioned devices and reclaim licenses"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "mobile, laptop",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["MDM", "BYOD", "Endpoint Security"]
    },
    {
        title: "Network Performance Tuning & QoS Optimization",
        description: "Make latency and jitter a thing of the past.",
        deliverables: [
          "Baseline network throughput, latency, jitter, packet loss stats",
          "Map critical apps & protocols that need priority handling",
          "Analyze congestion points via flow telemetry (NetFlow/sFlow)",
          "Re-architect QoS policies on WAN, LAN, and Wi-Fi gear",
          "Implement traffic shaping, policing, and DSCP marking",
          "Fine-tune TCP/UDP window & buffer sizes on servers",
          "Optimize WAN routes with SD-WAN path selection",
          "Test VoIP/video sessions under load; adjust queues & WRED",
          "Deploy continuous synthetic monitoring & alerting",
          "Document SLA metrics & escalation triggers",
          "Train IT team on interpreting performance dashboards",
          "Provide monthly health reports & capacity forecasts",
          "Optional 24/7 NOC monitoring for proactive incident response",
          "Quarterly tune-ups aligned with new app rollouts",
          "Recommendations for future bandwidth upgrades or peering"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "network",
        active: false,
        price: null,
        image: null,
        file: null,
        tags: ["Networking", "Performance", "QoS"]
      },
      {
        title: "Security Awareness Training Program Launch",
        description: "Human firewall 2.0—build culture, not checkboxes.",
        deliverables: [
          "Baseline user risk via phishing and USB bait tests",
          "Customize training curriculum by role (finance, dev, exec)",
          "Launch micro-learning modules (≤10 min) via LMS or email drip",
          "Gamify completion with badges, leaderboards, and rewards",
          "Schedule recurring phishing simulations with adaptive difficulty",
          "Provide just-in-time 'teachable moment' pop-ups for risky clicks",
          "Track metrics: phish-click rate, report rate, training completion",
          "Present quarterly exec report & heat-map of high-risk groups",
          "Host live Q&A webinars with security experts",
          "Integrate training records into HR onboarding & annual review",
          "Refresh content with latest threat trends & policies",
          "Offer optional deep-dive workshops for privileged users",
          "Maintain policy acknowledgment e-signatures for auditors",
          "Receive feedback from staff; iterate for engagement",
          "Celebrate milestones to reinforce positive behavior"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: null,
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "Awareness", "Training"]
      },
      {
        title: "Incident Response Plan Development & Table-Top Exercise",
        description: "Be ready when—not if—the breach happens.",
        deliverables: [
          "Catalogue assets, data classifications, and crown-jewel systems",
          "Define incident severity levels & communication protocols",
          "Draft step-by-step playbooks for common scenarios (ransomware, BEC, insider)",
          "Align roles & responsibilities across IT, legal, PR, execs",
          "Establish evidence handling & chain-of-custody guidelines",
          "Pre-stage forensic toolkits & secure jump boxes",
          "Configure incident ticketing, tagging, and time-stamped logs",
          "Conduct table-top exercise simulating multi-vector breach",
          "Record decisions, bottlenecks, and improvement opportunities",
          "Produce after-action report & prioritized remediation tasks",
          "Integrate IR plan with BCDR & vendor breach clauses",
          "Schedule follow-up full-scale red-team test",
          "Maintain plan version control & distribution list",
          "Provide incident-comm pack templates for media/clients",
          "Annual refresh or post-material-change update"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: null,
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["Security", "IR", "Compliance"]
      },
      {
        title: "SaaS Application Integration & SSO Enablement",
        description: "Tame SaaS sprawl while boosting productivity.",
        deliverables: [
          "Inventory existing SaaS contracts & shadow IT tools",
          "Map business workflows & data exchange requirements",
          "Select integration platform (iPaaS) or build custom APIs",
          "Establish identity provider & SSO federation across apps",
          "Configure SCIM provisioning & deprovisioning workflows",
          "Normalize data schemas & automate nightly sync jobs",
          "Implement role-based access & data-loss prevention policies",
          "Test end-to-end user journeys & error handling",
          "Monitor API performance & quota consumption",
          "Provide training docs & change-management comms",
          "Decommission redundant apps to cut costs",
          "Generate usage analytics & license allocation reports",
          "Integrate audit logs into central SIEM",
          "Continuous catalogue review for new SaaS requests",
          "Optional managed admin for license renewals & vendor liaison"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "cloud, web",
        active: false,
        price: null,
        image: null,
        file: null,
        tags: ["SSO", "SaaS", "Integration"]
      },
      {
        title: "Lifecycle Asset Management & License Optimization",
        description: "Unlock savings and prevent audit nightmares.",
        deliverables: [
          "Import asset records from purchase orders, discovery scans, spreadsheets",
          "Tag devices with owner, location, warranty, and depreciation schedule",
          "Map software titles to contracts, versions, and license seats",
          "Track renewal dates & create predictive budget forecasts",
          "Automate alerts for warranty expiry and end-of-life hardware",
          "Identify unused or under-utilized licenses for reharvest",
          "Compare actual installs versus entitlement to ensure compliance",
          "Integrate asset data with ServiceNow/Jira CMDB",
          "Provide CFO-ready cost-saving & risk-avoidance reports",
          "Coordinate recycling and data-sanitized disposal of retired gear",
          "Document lifecycle policies & secure storage guidelines",
          "Conduct annual true-up audit rehearsal",
          "Recommend bulk renewals or volume licensing to leverage discounts",
          "Enable self-service asset request workflows",
          "Continual improvement using analytics-driven insights"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "laptop, server, software",
        active: false,
        price: null,
        image: null,
        file: null,
        tags: ["ITAM", "Cost Optimization", "Compliance"]
    },
    {
        title: "AI-Driven Predictive Maintenance Dashboard",
        description: "Transform raw OT sensor streams into actionable uptime intelligence.",
        deliverables: [
          "Assess machinery telemetry sources, protocols, and retention",
          "Deploy edge collectors & secure data pipeline to cloud lake",
          "Cleanse, normalize, and feature-engineer time-series data",
          "Train regression & anomaly-detection models on historical failures",
          "Build alerting thresholds for remaining useful life (RUL) scores",
          "Create PowerBI/Grafana dashboard for ops & execs",
          "Integrate alerts into CMMS/ITSM for auto-ticketing",
          "Run pilot on critical line; measure downtime reduction",
          "Retrain models with retrievers for concept drift",
          "Document MLOps pipeline & hand-off to client IT",
          "Provide quarterly model-performance tune-ups",
          "Enable feedback loop from technicians via mobile app",
          "Publish ROI report on spare-part savings and OEE gains",
          "Optional 24/7 monitoring & managed MLOps support",
          "Align to ISO 5541 predictive maintenance standards"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "iot, industrial",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "MLOps", "Predictive Maintenance"]
      },
      {
        title: "Intelligent Document Processing & OCR Workflow",
        description: "Slash manual data entry hours with AI that reads documents.",
        deliverables: [
          "Gather sample invoices, POs, contracts to define extraction fields",
          "Evaluate OCR engines & transformer-based document AI models",
          "Train custom layout-aware models for high accuracy",
          "Build low-code workflow for classification, extraction, validation",
          "Integrate human-in-the-loop UI for confidence threshold review",
          "Connect output to ERP/CRM/APIs for seamless posting",
          "Implement PII/redaction module for compliance",
          "Benchmark latency & throughput SLA targets",
          "Deploy auto-scaling on serverless compute to control costs",
          "Monitor accuracy drift; schedule active-learning retraining",
          "Provide dashboard of processing volume & exception rate",
          "Generate audit trail & retention policy alignment",
          "Conduct user training & SOP handover",
          "Optional managed validation service for peak loads",
          "Quarterly model evaluation & field expansion updates"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "document, scanner, cloud",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "OCR", "Automation"]
      },
      {
        title: "Conversational AI Service Desk Chatbot",
        description: "Free your helpdesk while delighting employees with instant answers.",
        deliverables: [
          "Analyze top ticket categories & knowledge-base articles",
          "Choose LLM platform (OpenAI, Anthropic, Azure OpenAI) & guardrails",
          "Design conversation flows & persona tone voice aligned to brand",
          "Integrate SSO for personalized context & ticket status",
          "Connect to ITSM API for incident/request creation & updates",
          "Implement retrieval-augmented generation (RAG) from KB & SOP docs",
          "Configure hand-off to live agent on confidence drop or user request",
          "Set up feedback loop for answer quality scoring",
          "Fine-tune prompt engineering for concise, actionable replies",
          "Measure containment rate, CSAT, and time-to-resolution",
          "Secure chatbot endpoint with rate-limiting & auth tokens",
          "Train staff on analytics portal & intent tagging",
          "Roll out phased pilot & enterprise-wide expansion",
          "Optional multi-language support & voice IVR gateway",
          "Monthly prompt & KB refresh cadence"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "chat, web, mobile",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "LLM", "Helpdesk Automation"]
      },
      {
        title: "MLOps Pipeline & Governance Implementation",
        description: "Ship models to prod safely, repeatedly, and in audit-ready fashion.",
        deliverables: [
          "Assess current ML experimentation tooling & data lineage gaps",
          "Select version-controlled pipeline framework (MLflow, Kubeflow, SageMaker)",
          "Design CI/CD triggers for data, model, and code changes",
          "Implement automated testing (unit, integration, bias, drift)",
          "Containerize training/inference; publish to secure registry",
          "Set up feature store with access controls & monitoring",
          "Establish approval gates & rollback policies",
          "Deploy model registry with stage transitions & audit logs",
          "Integrate experiment tracking dashboards for stakeholders",
          "Train team on reproducibility, metadata, and SLA reporting",
          "Configure cost-allocation tagging for GPU/CPU spend",
          "Provide governance policy aligned to NIST AI RMF",
          "Conduct tabletop exercise for model failure scenario",
          "Optional 24/7 managed inference endpoint uptime SLA",
          "Quarterly review of ethical & compliance checkpoints"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "cloud, ml",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "MLOps", "Governance"]
      },
      {
        title: "AI-Powered Threat Hunting Automation",
        description: "Uncover stealthy attackers with ML that never sleeps.",
        deliverables: [
          "Aggregate log & telemetry sources into data lake",
          "Train unsupervised models for peer-group anomaly detection",
          "Feed threat-intelligence & contextual enrichment into pipeline",
          "Auto-generate hunt hypotheses & prioritized lead list",
          "Integrate with SOAR for autonomous response playbooks",
          "Validate detections against red-team or past incidents",
          "Tune model thresholds to balance noise vs. recall",
          "Provide hunt-dashboard with explainable AI narratives",
          "Conduct monthly threat-hunting sprints with analyst feedback",
          "Document findings & improve detection rules in SIEM",
          "Align process to MITRE D3FEND framework",
          "Offer option for continuous managed threat hunting",
          "Performance reporting on dwell-time reduction metrics",
          "Update models with new TTPs from threat feeds",
          "Annual maturity assessment & roadmap"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "cloud, security",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "Threat Detection", "Security Automation"]
      }, 
      {
        title: "Computer Vision Quality Inspection Setup",
        description: "Zero-defect manufacturing thanks to high-speed cameras + deep learning.",
        deliverables: [
          "Capture sample video/images of production line defects",
          "Select optimal lighting, lens, and camera FPS configuration",
          "Label dataset using assisted annotation tools",
          "Train CNN/Transformer model for defect classification & localization",
          "Deploy edge inference on GPU/ASIC for sub-100 ms latency",
          "Integrate PLC signals for instant reject/eject mechanism",
          "Build dashboard for real-time defect rate and trend analytics",
          "Calibrate threshold based on false-reject cost tolerance",
          "Provide redundancy strategy for camera or compute failure",
          "Train maintenance staff on re-calibration workflow",
          "Implement model retraining pipeline for new SKU variants",
          "Document SOP & regulatory compliance (FDA, ISO 13485 as needed)",
          "ROI analysis: scrap reduction, labor saving, throughput gain",
          "Optional 24/7 remote monitoring & tuning service",
          "Annual audit & hardware lifecycle upgrade plan"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "camera, gpu, manufacturing",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "Computer Vision", "Quality Control"]
      },
      {
        title: "Personalized Marketing Recommendation Engine",
        description: "Serve the right product to the right customer at the right time.",
        deliverables: [
          "Consolidate customer profiles, transactions, and click-stream into CDP",
          "Engineer features: recency, frequency, monetary, affinity vectors",
          "Train collaborative filtering & ranking models",
          "A/B test candidate algorithms for conversion uplift",
          "Deploy API endpoint for real-time recommendations (≤50 ms)",
          "Integrate into e-commerce, email, and mobile push channels",
          "Implement feedback capture for implicit & explicit signals",
          "Monitor KPIs: CTR, AOV, churn-reduction, revenue lift",
          "Establish model-retraining cadence tied to seasonality",
          "Comply with privacy laws (GDPR CCPA) & consent flags",
          "Provide marketing dashboard with cohort drill-downs",
          "Coordinate with creative team for dynamic content slots",
          "Roll out phased personalization tiers to mitigate risk",
          "Optional managed campaign optimization service",
          "Quarterly strategic review & roadmap"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "web, mobile, ecommerce",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "Personalization", "Marketing"]
      },
      {
        title: "AI-Driven Anomaly Detection for Finance & Ops",
        description: "Spot cost leaks, fraud, and operational hiccups in real-time.",
        deliverables: [
          "Ingest ERP, CRM, billing, and IoT sensor datasets",
          "Normalize, de-seasonalize, and scale numeric features",
          "Train ensemble models (Isolation Forest, LSTM, Prophet)",
          "Calibrate sensitivity to business tolerance for false positives",
          "Stream alerts to Slack/Teams & BI dashboards",
          "Correlate anomalies with external factors (weather, FX, campaigns)",
          "Automate root-cause suggestions via decision-tree explainer",
          "Integrate ticket creation & workflow assignment",
          "Measure MTTD & financial impact per anomaly class",
          "Provide monthly model-health & ROI reporting",
          "Enable feedback loop for analyst-labeled ground truth",
          "Optional managed monitoring & retraining service",
          "Align controls with SOX & PCI requirements",
          "Annual audit support & documentation packages",
          "Continuous expansion to new data domains"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "cloud, finance, iot",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "Anomaly Detection", "Finance"]
      },
      {
        title: "NLP Sentiment Analysis & Voice-of-Customer Engine",
        description: "Turn reviews and calls into actionable product insight.",
        deliverables: [
          "Aggregate text sources: chats, emails, reviews, call transcripts",
          "Select language models and sentiment taxonomy granularity",
          "Fine-tune on domain-specific lexicon & sarcasm patterns",
          "Build real-time streaming pipeline for sentiment scoring",
          "Tag intents, entities, and competitive mentions",
          "Surface trends in dashboard with drill-down to verbatim comments",
          "Alert product teams on emerging pain-points",
          "Correlate sentiment with NPS, churn, and sales metrics",
          "Provide feedback API for frontline reps to close loop",
          "Implement data privacy masking & access controls",
          "Quarterly model calibration to handle slang & new products",
          "Optional multi-language deployment across global markets",
          "Export insights to BI tools for stakeholder reporting",
          "Train customer-success team on interpreting insights",
          "Annual voice-of-customer strategy workshop"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "text, voice, customer-feedback",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "NLP", "Customer Experience"]
      },
      {
        title: "Generative AI Content Compliance Filter",
        description: "Keep LLM-generated content safe, brand-aligned, and policy-compliant.",
        deliverables: [
          "Catalog content policies (copyright, PII, profanity, brand tone)",
          "Build policy engine using transformer text classifiers & regex guards",
          "Integrate with enterprise content generation pipelines (CMS, email, chat)",
          "Provide real-time moderation API with allow/block/revise actions",
          "Configure brand-voice embeddings to flag off-tone wording",
          "Log moderation decisions for auditor traceability",
          "Deliver dashboard on violation trends and user behavior",
          "Train staff on safe prompt practices & red-teaming tactics",
          "Run adversarial testing to expose filter bypass vectors",
          "Adjust thresholds based on false-positive feedback",
          "Provide exportable compliance reports (HIPAA, COPPA, ESG)",
          "Optional legal review workflow integration",
          "Continuous model updates tracking new laws & brand guideline changes",
          "Disaster-recovery plan for model/API outage",
          "Annual governance workshop with legal & marketing"
        ],
        location: "on_site",
        usageType: "Metered",
        deviceTypes: "llm, cms, compliance",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        tags: ["AI service", "Generative AI", "Content Moderation"]
      },
      {
        title: "Entra ID Zero-Trust Identity Deployment",
        description: "Implement Entra ID with Zero Trust principles to enforce strong identity governance across hybrid or cloud-native environments.",
        deliverables: [
            "Kick-off to capture business units, legacy AD forests, and SSO ambitions",
            "Map users, groups, roles to least-privilege RBAC design",
            "Configure hybrid join, pass-through auth, or cloud sync cut-over path",
            "Enforce MFA, conditional access, compliant-device & risk-based policies",
            "Integrate HRIS for automated life-cycle provisioning via SCIM",
            "Enable privileged identity management with just-in-time elevation",
            "Roll out self-service password reset & access reviews",
            "Harden audit logs, diagnostic settings, long-term retention",
            "Build identity-protection detection rules for impossible travel & token replay",
            "Validate break-glass accounts, emergency access & recovery docs",
            "Decommission redundant on-prem identity servers post-stabilization",
            "Staff training on portal, logs, and access-review campaigns",
            "Executive dashboard with sign-in risk, MFA coverage, and KPIs",
            "30-day hyper-care & policy-tuning feedback loop",
            "Deliver runbooks and continuous-improvement roadmap"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop, Server",
        tags: ["Entra ID", "Identity Governance", "Security", "Zero Trust"]
      },
      {
        title: "Intune Unified Endpoint Management Roll-out",
        description: "Centralized device and application control using Microsoft Intune across diverse endpoints and ownership models.",
        deliverables: [
            "Inventory Windows, macOS, iOS, Android, Linux estate & ownership models",
            "Enroll devices via AutoPilot, ABM, Zero-Touch, or Android Enterprise",
            "Apply security baselines: encryption, firewall, credential guard, secure boot",
            "Deploy compliance and conditional-access gates back to Entra ID",
            "Publish app catalog, Win32 LOB packages, VPP, managed Google Play",
            "Configure MDM & MAM policies for BYOD container separation",
            "Automate OS-update rings & feature-update deferrals",
            "Integrate Defender for Endpoint device-risk signals",
            "Build remediation scripts leveraging PowerShell & shell profiles",
            "Enable analytics for battery health, driver crashes, and app hangs",
            "Establish lost-device wipe & selective-wipe workflows",
            "Train help-desk on remote-assist sessions & endpoint reporting",
            "Quarterly posture reviews and policy-drift reports",
            "Retire legacy SCCM GPO overlap; migrate workloads",
            "Optional co-management and autopatch service add-on"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop, Mobile, Tablet",
        tags: ["Endpoint Management", "Intune", "Security", "Modern Management"]
      },
      {
        title: "Microsoft 365 Tenant Hardening & Governance",
        description: "Harden Microsoft 365 services, secure collaboration, and ensure regulatory compliance via proactive governance controls.",
        deliverables: [
            "Baseline Secure Score, attack-surface, and shadow tenancy risks",
            "Configure organization-wide DLP, sensitivity labels, and retention policies",
            "Enforce modern auth; block basic & legacy IMAP/SMTP where possible",
            "Implement DKIM, SPF, DMARC with strict enforcement",
            "Tune anti-phish, safe links, safe attachment, and impersonation rules",
            "Create least-privilege admin roles; implement PIM & approval workflow",
            "Standardize naming conventions, site lifecycle, and collaboration policies",
            "Configure customer lockbox & information-barrier controls if required",
            "Automate licensing assignment via group-based entitlements",
            "Build adoption dashboard for Exchange, OneDrive, SharePoint, Teams",
            "Conduct user awareness sessions on secure sharing & guest access",
            "Establish change-control for new M365 preview features",
            "Periodic Secure Score delta reviews & roadmap alignment",
            "Documentation package for auditors & compliance teams",
            "Optional continuous compliance monitoring managed service"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop, Server",
        tags: ["Microsoft 365", "Compliance", "Security", "Governance"]
      },
      {
        title: "Teams Voice & Collaboration Enablement",
        description: "Enable robust voice and collaboration experiences with Microsoft Teams including PSTN, governance, and training.",
        deliverables: [
            "Gather PSTN requirements, number porting, and call-flow diagrams",
            "Configure Teams Phone, auto attendants, call queues, and resource accounts",
            "Integrate SBC or Operator Connect for certified carriers",
            "Deploy Teams Rooms devices & peripheral validation",
            "Establish governance for external access, guest channels, and shared chats",
            "Enable meeting policies—recording, transcription, watermark, lobby control",
            "Implement QoS tagging, DSCP marking across LAN/WAN for media",
            "Train staff on etiquette, breakout rooms, webinar hosting, whiteboard",
            "Launch adoption campaign with champions program & usage analytics",
            "Migrate legacy PBX features (park, pickup groups, E911)",
            "Configure survivable branch appliances for site resiliency",
            "Deploy compliance recording and archival if regulated",
            "Monthly call-quality report & trend insights",
            "Optional managed voice helpdesk & MAC-D service",
            "Yearly capacity review as user count scales"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: null,
        deviceTypes: "Laptop/Desktop, Phone, Conference Room Equipment",
        tags: ["Teams", "Voice", "Collaboration", "Unified Communications"]
      },
      {
        title: "Defender XDR Suite Deployment & SOC Integration",
        description: "Deploy and integrate Microsoft Defender XDR components to enable proactive threat protection and response in SOC workflows.",
        deliverables: [
            "Assess licensing (Defender for Endpoint, O365, Identity, Cloud Apps)",
            "Onboard endpoints via Intune, GPO, or third-party EDR coexistence",
            "Tune device, web, and application-control policies by risk appetite",
            "Enable attack-surface reduction rules & network protection",
            "Integrate Defender alerts into SIEM/SOAR with graph APIs",
            "Configure automated investigations & live response scripts",
            "Roll out Defender for O365 safe attachments/links across mail & Teams",
            "Activate identity-protection & cloud-app discovery policies",
            "Hunt across unified incident queue; build custom advanced hunting queries",
            "Establish SOC playbooks for containment and remediation",
            "Weekly threat-analytics briefings on emerging actor campaigns",
            "Executive dashboards: exposure score, MTTD, MTTR metrics",
            "Validate protections via red-team simulations & MITRE ATT&CK eval",
            "Optional 24/7 MDR subscription & proactive threat-hunting",
            "Quarterly posture health-check and license-tier optimization"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop, Server",
        tags: ["XDR", "Defender", "Security", "SOC", "AI"]
      },   
      {
        title: "Copilot for Microsoft 365 Adoption & Prompt Engineering",
        description: "Accelerate secure and effective adoption of Microsoft Copilot across departments through prompt engineering, governance, and ROI measurement.",
        deliverables: [
            "Confirm licensing eligibility & data-location compliance",
            "Map business-unit use-cases: summarization, drafting, insights, dev tasks",
            "Configure service policies: data-leak, privacy, and semantic index scope",
            "Deploy Copilot lab site with sandbox datasets for champions",
            "Conduct prompt-engineering workshop: system vs. user messages, tone, context",
            "Build curated prompt catalogue aligned to job functions",
            "Set up feedback widget & analytics for usage and sentiment",
            "Integrate Copilot with PowerPlatform connectors for workflow automation",
            "Implement content retention & eDiscovery alignment with Purview",
            "Evaluate impact on Secure Score & modify DLP where needed",
            "Draft governance charter: acceptable-use, human-in-the-loop, IP policies",
            "Drive adoption via lunch-and-learn, Yammer/Teams Q&A, contests",
            "Measure productivity KPIs, time-saved, and ROI dashboard",
            "Incorporate lessons into training LMS modules",
            "Continuous improvement: quarterly prompt refresh & feature rollout review"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1684369585080-11700ba4a9e9?q=80&w=3734&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop",
        tags: ["Copilot", "AI", "Microsoft 365", "Prompt Engineering", "Adoption"]
      },
      {
        title: "SharePoint Online Intranet & Knowledge Hub Build",
        description: "Design and deploy a modern SharePoint-based intranet for centralized knowledge sharing, communication, and document management.",
        deliverables: [
            "Collect branding assets, IA workshop with stakeholders for hub-site plan",
            "Configure hub & spoke topology, site templates, and navigation mega-menus",
            "Implement modern pages, web parts, Viva connections feed integration",
            "Migrate legacy file shares & on-prem sites with SPMT/ShareGate tooling",
            "Apply sensitivity labels, retention policies, and access reviews",
            "Automate metadata tagging & search schema refinements for findability",
            "Enable multilingual pages and audience targeting for global reach",
            "Train content owners on modern authoring & governance rules",
            "Establish approval workflows with Power Automate",
            "Launch comms plan: teaser videos, how-to guides, champion network",
            "Post-go-live adoption analytics and content-gap analysis",
            "Quarterly governance board meeting & feature roadmap",
            "Optional managed content curation & graphic design support",
            "Yearly intranet pulse survey and UX refresh recommendations",
            "Decommission redundant silos; enforce single source of truth"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: null,
        deviceTypes: "Laptop/Desktop",
        tags: ["SharePoint", "Intranet", "Knowledge Hub", "Governance"]
      },
      {
        title: "Azure Virtual Desktop (AVD) Deployment & Optimization",
        description: "Deploy and optimize Azure Virtual Desktop for secure, scalable virtual workspaces including GPU, FSLogix, and conditional access configurations.",
        deliverables:[
            "Gather user personas, app dependencies, GPU needs, and endpoint mix",
            "Design host-pool architecture, autoscale, and FSLogix profile storage",
            "Configure Azure AD join, conditional access, and MFA",
            "Harden session hosts: baseline image, Defender, group policy lockdown",
            "Integrate Intune for policy remediation and app deployment",
            "Set up monitoring via Log Analytics and Insights Workbook",
            "Optimize Teams AV redirection, RDP-shortpath, and screen capture",
            "Pilot with power users; capture performance & UX feedback",
            "Automate image updates via Azure Image Builder pipeline",
            "Build DR strategy across regions with BCDR runbooks",
            "Train help-desk on session shadowing and troubleshooting",
            "Monthly cost-optimization & right-size recommendations",
            "Document SOP, golden image maintenance, and lifecycle refresh",
            "Optional 24/7 NOC & patch management",
            "Annual capacity and license review"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: null,
        deviceTypes: "Laptop/Desktop, Server",
        tags: ["AVD", "Azure", "Virtual Desktop", "Remote Work"]
      },
      {
        title: "Purview & Compliance Manager Data-Governance Setup",
        description: "Establish enterprise-wide data governance and compliance using Microsoft Purview and Compliance Manager with automated score tracking and enforcement.",
        deliverables: [
            "Discover data estate across M365, Azure, SQL, on-prem connectors",
            "Configure built-in sensitive-info types & custom classifiers",
            "Apply data-map labels, data-loss prevention, and retention policies",
            "Deploy insider-risk, communication-compliance, and eDiscovery cases",
            "Automate compliance score improvement plan with task assignments",
            "Integrate non-Microsoft SaaS via API connectors for holistic view",
            "Build reporting dashboards for auditors and DPOs",
            "Conduct privacy-impact assessment workshops with legal & HR",
            "Configure double-key or customer-key encryption where mandated",
            "Implement access-review certifications for high-risk data locations",
            "Schedule quarterly compliance score reviews and action tracking",
            "Enable alerts for policy violation, unusual data access, mass exports",
            "Provide training to data-owners and custodians",
            "Create disaster-recovery plan for compliance data store",
            "Annual regulation update workshop & roadmap"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1614064548237-096f735f344f?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop, Server",
        tags: ["Purview", "Compliance", "Data Governance", "Security"]
      },
      {
        title: "Power Platform Automation & Citizen-Developer Enablement",
        description: "Enable low-code transformation and innovation at scale using Power Platform with a governed COE model and enterprise-ready automation practices.",
        deliverables: [
            "Inventory manual processes suitable for low-code automation",
            "Establish Centre of Excellence toolkit: governance, auditing, ALM",
            "Configure DLP policies to segregate business vs personal connectors",
            "Provide environment strategy—sandbox, dev, test, prod separation",
            "Build starter set of Power Apps, Automate flows, and Power BI reports",
            "Implement managed connectors to ERP/CRM & custom API gateways",
            "Train citizen developers on responsive UI, formulas, and connectors",
            "Launch hackathon to spark innovation and gather solution backlog",
            "Integrate apps with Teams for embedded experience",
            "Set up telemetry, analytics, and cost-allocation dashboards",
            "Conduct security reviews—role-based access, sharing, service principals",
            "Publish solution lifecycle playbook with pipelines and automated testing",
            "Quarterly COE committee to approve new connectors and review metrics",
            "Create champion network with recognition and knowledge-share sessions",
            "Continuous improvement loop—template gallery and feedback forum"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: null,
        deviceTypes: "Laptop/Desktop",
        tags: ["Power Platform", "Automation", "Citizen Developer", "Low-Code"]
      },  
      {
        title: "Zero-Touch Google Workspace Tenant Onboarding & Identity Sync",
        description: "Elevate productivity from day one with a friction-free Google Workspace rollout.",
        deliverables: [
            "Kick-off to capture business units, legacy mail systems, and domain portfolio",
            "Verify DNS ownership; set up SPF, DKIM, and DMARC for outbound trust",
            "Provision primary & alias domains; map OU hierarchy to org chart",
            "Sync identities with Google Cloud Directory Sync or SCIM from HRIS",
            "Configure SSO with SAML / OIDC to existing IdP; enforce 2-step verification",
            "Migrate mail, calendar, contacts via GWMME or third-party tools",
            "Deploy Chrome Policy and standard bookmarks through Chrome Management",
            "Create shared drives, access groups, and default sharing rules",
            "Implement context-aware access & BeyondCorp rules for zero-trust posture",
            "Activate Security Center: alert-center notifications, dashboards, and rules",
            "Conduct pilot with champion users; capture UX feedback",
            "Launch company-wide go-live—training, comms kit, quick-start guides",
            "Post-migration validation of MX, routing, alias completeness, calendar free-busy",
            "30-day hyper-care support & policy tuning",
            "Deliver runbook, asset inventory, and continuous-improvement roadmap"
        ],
        location: "on_site",
       usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop, Mobile",
        tags: ["Google Workspace", "Tenant Onboarding", "Identity Sync", "Security"]
      },
      {
        title: "Advanced Gmail Security & Phishing Defense",
        description: "Stop BEC, spoofing, and malware before it reaches the inbox.",
        deliverables: [
            "Baseline current email flow, routing rules, and third-party gateways",
            "Enable Google Workspace Enterprise security features—AI-driven threat scanning",
            "Configure SPF, DKIM (2048-bit), and p=reject DMARC enforcement",
            "Turn on Enhanced Safe Browsing, attachment sandbox, and link rewriting",
            "Build custom spam filters for C-suite name impersonation & display-name tricks",
            "Deploy Confidential Mode and client-side encryption for sensitive messages",
            "Integrate Gmail logs with BigQuery / SIEM for correlation",
            "Launch simulated phishing campaigns; track open/click metrics",
            "Train users to report phishing via integrated “Report” button",
            "Triage SOC workflow: auto-quarantine, header analysis, retroactive cleanup",
            "Weekly executive dashboards—delivery classification and false-positive rate",
            "Quarterly rule review; adjust thresholds for emerging TTPs",
            "Document escalation playbooks & SLA targets",
            "Optional managed detection-and-response add-on for 24 x 7 coverage",
            "Annual red-team email attack simulation for assurance"
        ],
        location: "on_site",
        usageType: "Metered",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        deviceTypes: "Laptop/Desktop",
        tags: ["Google Workspace", "Gmail Security", "Phishing Defense", "Threat Protection"]
      },
      {
        title: "Drive & Shared Drives Information Architecture & DLP",
        description: "Keep files discoverable, secure, and compliant.",
        deliverables: [
            "Workshop with departments to map content lifecycle & taxonomy",
            "Create shared drives per function; apply access groups & membership reviews",
            "Configure DLP rules for PII, PHI, PCI—block or warn on share violations",
            "Enable sensitivity labels & client-side encryption for crown-jewel docs",
            "Deploy target audiences & link-sharing restrictions (internal, trusted domains)",
            "Automate metadata tagging via Apps Script / API for search precision",
            "Migrate legacy file shares—incremental copy, delta sync, ACL mapping",
            "Set retention, legal-hold policies in Vault; align with records schedule",
            "Build Drive audit-log exports to BigQuery; surface anomalous sharing events",
            "Train content owners on best-practice folder hygiene & owner transfer",
            "Create self-service knowledge-base and champion network",
            "Quarterly permission recertification & stale-file cleanup",
            "Executive KPI dashboard—storage usage, external shares, DLP incidents",
            "Optional AI-powered classification for auto-labeling sensitive docs",
            "Continuous improvement loop—feedback intake & roadmap updates"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop",
        tags: ["Google Workspace", "Drive", "DLP", "Information Architecture"]
      },
      {
        title: "Google Meet & Voice Enterprise Deployment",
        description: "Crystal-clear meetings and cloud PBX without the headaches.",
        deliverables: [
            "Assess PSTN, E911, and international dialing requirements",
            "Port numbers or procure Google Voice pool; set call-flow & auto attendants",
            "Configure Meet hardware kits; test HDMI, PoE, and calendar integration",
            "Enable adaptive framing, noise cancelation, and recording retention settings",
            "Implement QoS—DSCP tags, bandwidth caps, and SD-WAN path steering",
            "Integrate SIP interop gateways for legacy conference rooms",
            "Train users on breakout rooms, polls, Q&A, and live-stream options",
            "Establish governance: meeting recording, Drive storage quotas, guest access",
            "Create Meet compliance recording via third-party API where regulated",
            "Deploy call-quality dashboard & alert rules in Admin Console",
            "Pilot with high-volume call center for Voice, adjust license mix",
            "Launch adoption campaign—how-to videos, virtual roadshows",
            "Monthly call-quality report—MOS scores, packet loss, jitter heatmaps",
            "Optional managed Voice helpdesk with MAC-D services",
            "Annual capacity and codec review to support growth"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop, Mobile",
        tags: ["Google Workspace", "Google Meet", "Google Voice", "Enterprise Communication"]
      },
      {
        title: "Endpoint Management & BeyondCorp Zero-Trust Enforcement",
        description: "Secure every laptop, mobile, and ChromeOS device—on or off VPN.",
        deliverables: [
            "Inventory device fleet; segment corporate vs BYOD endpoints",
            "Enroll ChromeOS via zero-touch, Android via Android Enterprise, iOS via ABM",
            "Apply device-based 2-step verification and screen-lock policies",
            "Deploy endpoint verification extension—collect OS, disk-encryption, patch status",
            "Configure context-aware access: block high-risk devices, check OS version",
            "Enforce Titan M-based verified boot for ChromeOS & firmware lock for Mac/Win",
            "Automate OS updates & browser patch cadence via Admin policies",
            "Push Wi-Fi, VPN, and certificate profiles automatically",
            "Enable lost-device wipe, selective wipe for BYOD",
            "Export device logs to BigQuery for fleet analytics",
            "Train support desk on remote wipe & troubleshooting",
            "Quarterly compliance snapshot—encryption, jailbreak/root, obsolete OS",
            "Optional BeyondCorp Enterprise Threat & Data protection add-on",
            "Continuous policy tuning and new-device model certification",
            "Annual zero-trust maturity assessment & roadmap"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop, Mobile, ChromeOS",
        tags: ["Google Workspace", "Endpoint Management", "Zero Trust", "BeyondCorp", "Security"]
      },
      {
        title: "Vault eDiscovery & Legal Hold Compliance Program",
        description: "Never scramble again when subpoenas arrive.",
        deliverables: [
          "Identify custodians, data sources (Gmail, Drive, Chat, Meet, Voice)",
          "Configure retention rules—indefinite, time-based, or event-based",
          "Establish legal-hold processes with automated notifications",
          "Train legal team on search, preview, export, and privilege tags",
          "Integrate Vault export with Relativity / Reveal for review",
          "Automate chain-of-custody logs and hash verification",
          "Test disaster-recovery restore and cross-region redundancy",
          "Build standardized request-intake workflow using App Sheet/Form",
          "Quarterly hold review to release stale matters and cut storage",
          "Provide executive summary—open matters, size, compliance score",
          "Draft policy documentation for SOX, HIPAA, GDPR audits",
          "Optional managed eDiscovery service for large-scale litigation",
          "Yearly mock subpoena drill for readiness",
          "Continuous monitoring of Google roadmap for new data types",
          "Maintain playbook version control and access rights"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop",
        tags: ["Google Workspace", "eDiscovery", "Compliance"]
      },
      {
        title: "Security Center Monitoring & Automated Incident Response",
        description: "Harness Google AI to triage threats in minutes, not days.",
        deliverables: [
          "Enable Security Center, select Premium coverage, and tune alert rules",
          "Integrate BigQuery exports for long-term log retention & ML analytics",
          "Build Chronicle feed or third-party SIEM forwarding via Pub/Sub",
          "Configure rule-based and anomaly-based detection policies",
          "Automate SOAR playbooks—auto-suspend account, revoke tokens, isolate device",
          "Correlate Workspace alerts with VirusTotal & Mandiant threat intel",
          "Establish incident-severity matrix and on-call rotations",
          "Run red-team phishing + OAuth token abuse to validate detections",
          "Weekly hunt sprints using BigQuery detection-engine queries",
          "Generate MTTR, MTTD, and dwell-time dashboards for execs",
          "Conduct post-incident review & detection-logic improvements",
          "Provide playbook library—ransomware, insider threat, BEC",
          "Optional 24 x 7 managed SOC overlay",
          "Quarterly tuning workshop & roadmap alignment",
          "Annual tabletop exercise for audit evidence"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop",
        tags: ["Google Workspace", "Security", "Incident Response"]
      },
      {
        title: "AppSheet Citizen-Developer Center of Excellence",
        description: "Empower line-of-business users to build secure, scalable apps.",
        deliverables: [
          "Launch AppSheet licenses; map data connectors to Sheets, SQL, Drive",
          "Install COE toolkit—governance, review process, template gallery",
          "Train citizen devs on UX, data security, and performance best practice",
          "Establish environment tiers—dev, test, prod with approval gates",
          "Implement DLP and row-level security policies for sensitive data",
          "Create starter templates—expense tracker, field service, inventory audit",
          "Integrate apps with Workspace add-ons and mobile deployments",
          "Set up monitoring—usage stats, error logs, API quotas",
          "Quarterly hackathon; recognize top solutions & share stories",
          "Review app backlog for opportunities to formalize into core IT",
          "Document ALM pipeline and change-management SOP",
          "Optional pro-dev integration (Apps Script / Cloud Run extensions)",
          "Annual ROI review—hours saved, process speed, user satisfaction",
          "Update policy & connector list based on Google roadmap",
          "Continuous feedback loop with dev community"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop, Mobile/Tablet",
        tags: ["Google Workspace", "AppSheet", "Citizen Development"]
      },
      {
        title: "Google Chat & Spaces Collaboration Governance",
        description: "Keep conversations flowing without losing control.",
        deliverables: [
          "Define Chat vs Space use-cases; establish naming conventions & owners",
          "Configure external messaging controls, trusted domains, and allow/block list",
          "Turn on DLP for Chat—block sensitive data exfiltration",
          "Enable Chat API logs to BigQuery for sentiment & abuse analytics",
          "Deploy custom bots for ticket creation, approvals, and polls",
          "Implement retention & legal-hold policies in Vault",
          "Train users on threaded vs unthreaded spaces, in-line tasks, and Meet integration",
          "Launch champions program & etiquette guidelines",
          "Monitor adoption metrics—messages per user, active spaces",
          "Quarterly audit of orphaned spaces, inactive bots, and owner recertification",
          "Draft escalation workflow for harassment or data-leak incidents",
          "Provide executive dashboard—top channels, guest usage, DLP hits",
          "Optional profanity & toxicity filter add-on",
          "Continuous improvement via feedback form & feature roadmap",
          "Annual policy review aligned with HR and legal"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop, Mobile/Tablet",
        tags: ["Google Workspace", "Chat", "Governance"]
      },
      {
        title: "Workspace Data-Loss Prevention & Insider-Risk Program",
        description: "Guard your IP and client data on every channel.",
        deliverables: [
          "Catalogue sensitive data patterns—client lists, financials, source code",
          "Configure Workspace DLP rules for Gmail, Drive, Chat, and Meet recordings",
          "Set action matrix—warn, quarantine, or block, with manager notify",
          "Deploy OCR-based DLP for image-based data exfiltration",
          "Integrate context-aware access to restrict external sharing on risky devices",
          "Combine Drive labels with Vault retention & hold strategies",
          "Enable audit-log exports; run BigQuery ML to detect anomalous shares",
          "Launch insider-risk awareness training & acknowledgment policy",
          "Build SOAR playbooks—auto-revoke sharing, suspend account, alert SOC",
          "Quarterly risk review—top violators, rule effectiveness, false-positive tuning",
          "Executive heat-map—risk by department and data category",
          "Document regulatory mappings—HIPAA, CCPA, ITAR, GDPR",
          "Optional BeyondCorp Data Protection for web exfiltration control",
          "Continuous rule refinement as new data classes emerge",
          "Yearly penetration test & tabletop drill to validate controls"
        ],
        location: "on_site",
        active: false,
        price: null,
        image: null,
        file: "https://images.unsplash.com/photo-1678483790053-71367bc7a02c?q=80&w=3628&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        usageType: "Metered",
        deviceTypes: "Laptop/Desktop",
        tags: ["Google Workspace", "DLP", "Insider Risk"]
      },
    {
        title: "Computer Maintenance and Cleaning",
        description: "Interior cleaning of a desktop or laptop, re-application of thermal paste if needed and ensuring proper air flow is achieved.",
        deliverables: [
            "Visibly inspect the inside of desktop/laptop looking for dust build up",
            "In older desktops, reapply thermal paste between the CPU and heat sink because it gets dry and brittle over time",
            "Use laser-eye disc cleaner to rinse your disk drive's optical eye",
            "Ensure the PC has proper air flow and clean fans to be able to dissipate heat properly",
        ],
        location: "on_site",
        deviceTypes: "Desktop,Laptop",
        active: false,
        price: null,
        usageType: "Metered",
        "image": "desktop.jpeg",
        file: 'https://images.unsplash.com/photo-1542435503-956c469947f6?fit=crop&w=450&q=80',
        tags: ["Basic Services", "Maintenance", "Cleaning"]
    },
    {
        title: "TV Setup",
        description: "Setup new and used TVs.",
        deliverables: [
            "Connect all necessary video components and cables",
            "Configure a sound bar if needed",
            "Set up of necessary peripherals",
            "Configure an existing wireless network",
        ],
        location: "on_site",
        deviceTypes: "TV",
        active: false,
        price: null,
        usageType: "Metered",
        "image": "television-support.jpeg",
        file: 'https://images.unsplash.com/photo-1461151304267-38535e780c79?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dGVsZXZpc2lvbnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Setup", "TV"]
    },
    {
        title: "Password Recovery and Reset",
        description: "Help reset or recover password and gain access to your account.",
        deliverables: [
            "Assist in resetting or recovering password.",
        ],
        location: "on_site",
        // deviceTypes: "Desktop,Laptop,Phone,Tablet",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: "security-checkup.jpg",
        file: 'https://images.unsplash.com/photo-1593642702909-dec73df255d7?fit=crop&w=450&q=80',
        tags: ["Basic Services", "Security", "Password"]
    },
    {
        title: "Mobile Device Setup (android and iOS)",
        description: "Setup new and used Mobiles",
        deliverables: [
            "Set up a phone, ensuring it's connected to Wi-Fi",
            "Configure an email account on the device",
            "Setup google play or app store",
            "Configure basic settings on the device",
            "Download and install all required apps",
        ],
        location: "on_site",
        deviceTypes: "Phone,Tablet",
        active: false,
        price: null,
        usageType: "Metered",
        image: "mobile-device-setup.jpg",
        file: 'https://images.unsplash.com/photo-1612442443556-09b5b309e637?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8YW5kcm9pZCUyMHBob25lfGVufDB8MHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Setup", "Mobile"]
    },
    {
        title: "Printer Setup",
        description: "Setup and install Printers",
        deliverables: [
            "Configure and test new printer",
            "Ensuring it has ink cartridges inserted correctly",
            "Connect it to Wi-Fi network or any other devices.",
            "Demonstrate basic printer functionalities and its working",
        ],
        location: "on_site",
        deviceTypes: "Printer",
        active: false,
        price: null,
        usageType: "Metered",
        image: "printer-setup.jpeg",
        file: 'https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8cHJpbnRlcnxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Setup", "Printer"]
    },
    {
        title: "Computer Security checkup- Virus Removal and Tune Up",
        description: "Scan computer viruses and clean up OS for better performance",
        deliverables: [
            "Perform a full scan for viruses, spyware, and malware and remove",
            "Install supplied antivirus if needed",
            "Removal of temp files",
            "Uninstall unneeded and or unwanted computer programs",
            "Fix computer errors",
            "Clean up the registry",
        ],
        location: "on_site",
        deviceTypes: "Desktops, Laptops",
        active: false,
        price: null,
        usageType: "Metered",
        image: "computer-refresh.jpg",
        file: 'https://images.unsplash.com/photo-1493723843671-1d655e66ac1c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjV8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Security", "Virus Removal"]
    },
    {
        title: "Data Backup or Transfer",
        description: "Back up all personals files or transfer to new computer",
        deliverables: [
            "Backup data to a CD or DV. ",
            "Backup data to an external hard drive",
            "Backup data to the cloud",
            "Transfer files to new PC",
        ],
        location: "on_site",
        deviceTypes: "Desktops,Laptops,Phone,Tablet",
        active: false,
        price: null,
        usageType: "Metered",
        image: "data-backup.jpeg",
        file: 'https://images.unsplash.com/photo-1587831990711-23ca6441447b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDR8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Backup", "Transfer"]
    },
    {
        title: "Home Theater Setup",
        description: "Ensuring home theater audio & video device connections",
        deliverables: [
            "Assess installation area",
            "Connect audio and video equipment in one room",
            "Connect any capable devices to an existing wireless network",
            "Connect other devices if necessary",
            "Give a walk-through of the new system",
        ],
        location: "on_site",
        deviceTypes: "TV",
        active: false,
        price: null,
        usageType: "Metered",
        image: "home-theater.jpeg",
        file: 'https://images.unsplash.com/flagged/photo-1572609239482-d3a83f976aa0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MXx8aG9tZSUyMHRoZWF0ZXJ8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Setup", "Home Theater"]
    },
    {
        title: "Email or Online Account Setup Support",
        description: "Setup new email accounts and fix email issues",
        deliverables: [
            "Setup active or new email account",
            "Configure account settings and features",
            "Demonstrate email functionalities",
            "Troubleshoot Account issues",
        ],
        location: "on_site",
        // deviceTypes: "Laptops, Desktops, Mobiles, Tablets",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: "email-setup.jpeg",
        file: "https://images.unsplash.com/photo-1603791440384-56cd371ee9a7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=618&q=80",
        tags: ["Basic Services", "Setup", "Email"]
    },
    {
        title: "New Wi-Fi Setup",
        description: "Setup new Wi-Fi device",
        deliverables: [
            "Install and configure Wi-Fi",
            "Setup custom password if required",
            "Connect all devices to new Wi-Fi ",
        ],
        location: "on_site",
        deviceTypes: "WiFi",
        active: false,
        price: null,
        usageType: "Metered",
        image: "wifi-setup.jpeg",
        file: 'https://images.unsplash.com/photo-1603731955926-81917dad5a80?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Setup", "Wi-Fi"]
    },
    {
        title: "Computer Refresh",
        description: "Cleaning up old files and making sure the device is running at its optimum speed",
        deliverables: [
            "Check all power, system, and boot settings to ensure the best performance.",
            "Perform a disk clean-up",
            "Check and make sure windows is up-to-date.  ",
            "Recommend and install some good anti-virus software for extra protection.",
        ],
        location: "on_site",
        deviceTypes: "Desktop,Laptop",
        active: false,
        price: null,
        usageType: "Metered",
        image: "computer-setup.jpg",
        file: 'https://images.unsplash.com/photo-1614624532983-4ce03382d63d?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjZ8fGRlc2t0b3B8ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Maintenance", "Computer"]
    },
    {
        title: "TV Repair",
        description: "Check if a TV is repairable before disposing",
        deliverables: [
            "Check the most common reasons a TV would go out (capacitors, power board, etc)",
            "Replace the damaged parts with the new ones",
            "Do basic TV settings like brightness and contrast",
            "Tune up for latest channels",
        ],
        location: "on_site",
        deviceTypes: "TV",
        active: false,
        price: null,
        usageType: "Metered",
        image: "television-setup.jpeg",
        file: 'https://images.unsplash.com/photo-1601944179066-29786cb9d32a?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjR8fHRlbGV2aXNpb258ZW58MHwwfDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Repair", "TV"]
    },
    {
        title: "Streaming Device Setup and Support",
        description: "Help setup your new streaming device like Apple TV, Chromecast, Roku or Amazon Fire TV and more.",
        deliverables: [
            "Connect a streaming device to your TV and run the setup",
            "Install streaming video apps",
            "Connect the device to available internet resource",
            "Demonstrate the full functionality",
        ],
        location: "on_site",
        deviceTypes: "TV",
        active: false,
        price: null,
        usageType: "Metered",
        image: "streaming-device.jpeg",
        file: 'https://images.unsplash.com/photo-1615986201152-7686a4867f30?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=625&q=80',
        tags: ["Basic Services", "Setup", "Streaming Device"]
    },
    {
        title: "Wi-Fi security settings and optimization",
        description: "Update your router with the latest security features",
        deliverables: [
            "Configure and secure a router",
            "Ensure a strong and secured password",
            "Troubleshoot connectivity issues and optimize Wi-Fi networks for better performance",
        ],
        location: "on_site",
        deviceTypes: "WiFi",
        active: false,
        price: null,
        usageType: "Metered",
        image: "wifi-optimize.jpeg",
        file: 'https://images.unsplash.com/photo-1606904825846-647eb07f5be2?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8d2lmaXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Security", "Wi-Fi"]
    },
    {
        title: "Technology Recycling",
        description: "Take the dead electronic items to the Recycler.",
        deliverables: [
            "Recycling technologies and use waste materials to make new products. Used or damaged parts can be used in making refurbished devices and batteries.",
        ],
        location: "on_site",
        deviceTypes: null,
        active: false,
        price: null,
        usageType: "Metered",
        image: "technology-recycling.png",
        file: 'https://images.unsplash.com/photo-1518770660439-4636190af475?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80',
        tags: ["Basic Services", "Recycling", "Technology"]
    },
    {
        title: "Mobile Device Repair",
        description: "Help solve common mobile device problems, so you can stay connected.",
        deliverables: [
            "Have your cracked or damaged phone screen replaced",
            "Clean your charging port and remove anything that is obstructing the connection.",
            "Ensure your device is functioning properly",
        ],
        location: "on_site",
        deviceTypes: "Phone,Tablet",
        active: false,
        price: null,
        usageType: "Metered",
        image: "screen-repair.jpeg",
        file: 'https://images.unsplash.com/photo-1480694313141-fce5e697ee25?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8c21hcnRwaG9uZXxlbnwwfDB8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        tags: ["Basic Services", "Repair", "Mobile Device"]
    },
];
export const BRANDS = [
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'desktop', 'laptop', 'accessory', 'tv', 'printer'],
        image: 'https://cdn0.iconfinder.com/data/icons/logos-21/40/Samsung-128.png',
        option: 'Samsung'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'desktop', 'laptop', 'accessory'],
        image: 'https://cdn3.iconfinder.com/data/icons/logos-brands-3/24/logo_brand_brands_logos_apple_ios-128.png',
        option: 'Apple'
    },
    {
        key: ['phone', 'tablet', 'desktop', 'laptop'],
        image: 'https://cdn4.iconfinder.com/data/icons/social-media-logos-6/512/78-microsoft-128.png',
        option: 'Microsoft'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'desktop', 'laptop', 'accessory'],
        image: 'https://cdn1.iconfinder.com/data/icons/metro-ui-dock-icon-set--icons-by-dakirby/128/Lenovo.png',
        option: 'Lenovo'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'desktop', 'laptop', 'accessory', 'wifi'],
        image: 'https://cdn1.iconfinder.com/data/icons/metro-ui-dock-icon-set--icons-by-dakirby/128/Asus.png',
        option: 'ASUS'
    },
    {
        key: ['desktop', 'laptop', 'tablet', 'printer'],
        image: 'https://cdn1.iconfinder.com/data/icons/metro-ui-dock-icon-set--icons-by-dakirby/128/Dell_alt.png',
        option: 'DELL'
    },
    {
        key: ['desktop', 'laptop', 'accessory', 'printer', 'vr', 'virtual reality', 'tablet', 'vr headset'],
        image: 'https://cdn1.iconfinder.com/data/icons/metro-ui-dock-icon-set--icons-by-dakirby/128/HP.png',
        option: 'HP'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/xiaomi-128.png',
        option: 'Xiaomi'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'accessory', 'wifi'],
        image: 'https://cdn2.iconfinder.com/data/icons/social-icons-33/128/Google-128.png',
        option: 'Google'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'desktop', 'laptop', 'smart watch'],
        image: 'https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/huawei-128.png',
        option: 'Huawei'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/nokia-128.png',
        option: 'Nokia'
    },
    {
        key: ['phone', 'smartphone', 'smart phone', 'mobile', 'accessory', 'desktop', 'laptop', 'tv', 'smart watch'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/sony-128.png',
        option: 'Sony'
    },
    {
        key: ['desktop', 'laptop'],
        image: 'https://cdn1.iconfinder.com/data/icons/metro-ui-dock-icon-set--icons-by-dakirby/128/Acer.png',
        option: 'Acer'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'accessory', 'tv', 'desktop', 'laptop'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/lg-128.png',
        option: 'LG'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile', 'smart watch'],
        image: 'https://cdn0.iconfinder.com/data/icons/Puck_Icons_Pack_II_by_deleket/128/Motorola.png',
        option: 'Motorola'
    },
    {
        key: ['game system', 'game', 'gaming console', 'gaming', 'console', 'gaming system'],
        image: 'https://cdn0.iconfinder.com/data/icons/social-flat-buttons-3/512/xbox-128.png',
        option: 'Xbox'
    },
    {
        key: ['game system', 'game', 'gaming console', 'gaming', 'console', 'gaming system'],
        image: 'https://cdn2.iconfinder.com/data/icons/social-flat-buttons-3/512/playstation-128.png',
        option: 'Play Station'
    },
    {
        key: ['game system', 'game', 'gaming console', 'gaming', 'console', 'gaming system'],
        image: 'https://cdn1.iconfinder.com/data/icons/game-asset-2/24/nitendo_switch-128.png',
        option: 'Nitendo Switch'
    },
    {
        key: ['game system', 'game', 'gaming console', 'gaming', 'console', 'gaming system'],
        image: 'https://cdn1.iconfinder.com/data/icons/game-asset-2/24/nitendo_switch-128.png',
        option: 'Nitendo Wii'
    },
    {
        key: ['vr', 'vr headset', 'virtual reality'],
        image: 'https://cdn2.iconfinder.com/data/icons/css-vol-2/24/oculus-128.png',
        option: 'Oculus'
    },
    {
        key: ['vr', 'vr headset', 'virtual reality', 'phone', 'smartphone', 'smart phone', 'mobile'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/htc-128.png',
        option: 'HTC Vive'
    },
    {
        key: ['desktop', 'laptop'],
        image: 'https://pbs.twimg.com/profile_images/1346135292432982018/lQqtg6qy_400x400.png',
        option: 'iBUYPOWER'
    },
    {
        key: ['desktop', 'laptop'],
        image: 'https://cdn1.iconfinder.com/data/icons/_dock_icons___by_adrenn/128/alienware.png',
        option: 'Alienware'
    },
    {
        key: ['desktop'],
        image: 'https://www.pngitem.com/pimgs/m/592-5924082_cyberpower-pc-logo-hd-png-download.png',
        option: 'CyberPowerPC'
    },
    {
        key: ['desktop', 'laptop'],
        image: 'https://logosvector.net/wp-content/uploads/2021/08/msi-logo-symbol.png',
        option: 'MSI'
    },
    {
        key: ['desktop', 'laptop', 'printer'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/toshiba-1-282829.png',
        option: 'Toshiba'
    },
    {
        key: ['laptop'],
        image: 'https://www.thegamingeconomy.exchangewire.com/files/2020/01/Razer-logo.png',
        option: 'Razer'
    },
    {
        key: ['laptop', 'printer'],
        image: 'https://i0.wp.com/www.fusionpr.com/wp-content/uploads/2017/02/Fujitsu-Logo.png?ssl=1',
        option: 'Fujitsu'
    },
    {
        key: ['laptop'],
        image: 'https://e7.pngegg.com/pngimages/458/837/png-clipart-logo-gigabyte-technology-organization-font-docx-resume-blue-text.png',
        option: 'GIGA BYTE'
    },
    {
        key: ['laptop'],
        image: 'https://cf.shopee.com.my/file/0956f9cfd0668401c4a3e2958c9260a1',
        option: 'BMAX'
    },
    {
        key: ['laptop'],
        image: 'https://united-comm.com/wp-content/uploads/2011/02/Infinix-logo.png',
        option: 'Infinix'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile'],
        image: 'https://wallpaperaccess.com/full/4392106.jpg',
        option: 'Oppo'
    },
    {
        key: ['phone', 'tablet', 'smartphone', 'smart phone', 'mobile'],
        image: 'http://ocdn.eu/images/pulscms/Mjc7MDA_/d88897b371dffe00079b24122922aa79.jpg',
        option: 'Vivo'
    },
    {
        key: ['tablet'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/amazon-128.png',
        option: 'Amazon'
    },
    {
        key: ['tablet'],
        image: 'https://cdn4.iconfinder.com/data/icons/flat-brand-logo-2/512/nvidia-128.png',
        option: 'Nvidia'
    },
    {
        key: ['tv'],
        image: 'https://upload.wikimedia.org/wikipedia/commons/4/48/Skyworth_logo_2.jpg',
        option: 'Skyworth'
    },
    {
        key: ['tv'],
        image: 'https://logowik.com/content/uploads/images/hisense2847.jpg',
        option: 'Hisense'
    },
    {
        key: ['tv'],
        image: 'https://logicoolair.com.au/wp-content/uploads/2020/08/Panasonic_logo.jpg',
        option: 'Panasonic'
    },
    {
        key: ['tv'],
        image: 'https://www.vizio.com/content/dam/vizio/2021/global/logo-social-preview.jpg',
        option: 'Vizio'
    },
    {
        key: ['tv'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/philips-282137.png',
        option: 'Philips'
    },
    {
        key: ['tv'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/hitachi-283255.png',
        option: 'Hitachi'
    },
    {
        key: ['wifi'],
        image: 'https://companiesmarketcap.com/img/company-logos/256/NTGR.png',
        option: 'Netgear'
    },
    {
        key: ['wifi'],
        image: 'https://b.thumbs.redditmedia.com/Z910Q3MzFmW6HE769fPrczdVHx0S7wmZaMCmXz_6TUA.png',
        option: 'Tp-Link'
    },
    {
        key: ['wifi'],
        image: 'https://www.netspotapp.com/images/upload/icons/Linksys@2x.png',
        option: 'Linksys'
    },
    {
        key: ['wifi'],
        image: 'http://damienjule.com/wp-content/uploads/2020/09/logo-synology-square.png',
        option: 'Synology'
    },
    {
        key: ['printer'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/canon-1863563-1579771.png',
        option: 'Canon'
    },
    {
        key: ['printer'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/epson-283249.png',
        option: 'Epson'
    },
    {
        key: ['printer'],
        image: 'https://static.netify.ai/logos/b/r/o/oebgure/icon.png?v=2',
        option: 'Brother'
    },
    {
        key: ['printer'],
        image: 'https://www.westcoast.co.uk/Images/Product/Default/medium/lexmark-logo.jpg',
        option: 'Lexmark'
    },
    {
        key: ['printer'],
        image: 'https://udger.com/pub/img/brand/kyocera_big.png',
        option: 'Kyocera'
    },
    {
        key: ['printer'],
        image: 'https://companiesmarketcap.com/img/company-logos/256/XRX.png',
        option: 'Xerox'
    },
    {
        key: ['smart watch'],
        image: 'https://cdn0.iconfinder.com/data/icons/logos-21/40/Samsung-128.png',
        option: 'Samsung Galaxy Watch'
    },
    {
        key: ['smart watch'],
        image: 'https://cdn3.iconfinder.com/data/icons/logos-brands-3/24/logo_brand_brands_logos_apple_ios-128.png',
        option: 'Apple Watch'
    },
    {
        key: ['smart watch'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/fitbit-3628774-3030136.png',
        option: 'Fitbit'
    },
    {
        key: ['smart watch'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/garmin-282119.png',
        option: 'Garmin'
    },
    {
        key: ['smart watch'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/suunto-282825.png',
        option: 'Suunto'
    },
    {
        key: ['game system', 'game', 'gaming console', 'gaming', 'console', 'gaming system'],
        image: 'https://cdn.iconscout.com/icon/free/png-256/sega-2-282703.png',
        option: 'Sega'
    },
];
export const DEFAULT_SCHEDULE = {
    "Schedule": {
        "Monday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],
        "Tuesday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],
        "Wednesday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],
        "Thursday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],
        "Friday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],
        "Saturday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],
        "Sunday": [
            {
                "Start_Time": "00:00:00.000Z",
                "End_Time": "23:59:00.000Z"
            }
        ],

    },
    "Schedule_Amendments": []
};

const SECRET_KEY = 'cTAAAAAJcZVRqyHZKhI'

export function encryptString(string) {
    let ciphertext = CryptoJS.AES.encrypt(string, SECRET_KEY).toString();
    return ciphertext;
}

export function decryptString(ciphertext) {
    let bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText ? originalText : ciphertext;
}

export function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

export function ucwords(str, lower = false) {
    return (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
    ;
}

export function toCustomStatus(status, bookingStatus) {
    let newStatus = status;
    if (status === 'Accepted')
        newStatus = 'Scheduled';
    else if (status === 'Confirmed')
        newStatus = 'Paid';
    else if (status === 'Completed' && bookingStatus === 'Confirmed')
        newStatus = 'Paid';

    return newStatus;

}

export function TouchPointLogout(id) {
    ApiBaseHelper.delete({
        url: `touchpoint/` + id
    })
    FirebaseHelper.logout()
}

export async function initiateWebConference({conversationId, caller, participant, redirect = true}) {
    await FirebaseHelper.set({
        path: `conferences/${conversationId}`,
        data: {
            "caller": caller,
            "participant": participant,
            "declined": false,
            "accepted": false,
            "connected": false,
        }
    });

    await FirebaseHelper.set({
        path: `users/${participant.id}`,
        data: conversationId
    });
    if (redirect)
        window.open(ROUTES.VIDEO_CONFERENCING.replace(':channel', conversationId), '_blank');
}

export async function getUserProfile(
    {
        orgId,
        token,
        tech,
        dispatch,
        redirectTarget = "_self",
        touchPoint,
        redirect = true,
        emailVerification = false,
        isSendVerificationEmail = false,
        role,
        organization,
        email,
        password,
        isAdmin = false,
        newSignup=false
    }
) {

    try {
        let getProfileResponse = await ApiBaseHelper.get({
            url: "user", headers: {
                Authorization: 'Bearer ' + token
            }
        });
        getProfileResponse = getProfileResponse.data.data;

        let validateTech = await ApiBaseHelper.get({
            url: `web/tech-account?email=${email}`,
        });

        let getEmailAndRoleStatus

        if(!isAdmin){
            getEmailAndRoleStatus = await ApiBaseHelper.post({
                url: "web/get-verification-and-role", payload: {
                    "email": email,
                    "password": password
                }
            });
            getEmailAndRoleStatus = getEmailAndRoleStatus.data.data;
        }

        const name = getProfileResponse.Full_Name.split(" ");
        if (tech) {
            let techProfile = {
                "firstname": name[0].charAt(0).toUpperCase() + name[0].slice(1),
                "lastname": name[1].charAt(0).toUpperCase() + name[1].slice(1),
                "phone": getProfileResponse.Personal_Phone,
                "imageUrl": getProfileResponse.imgUrl,
                "email": getProfileResponse.Email_Address,
                'token': token,
                'id': getProfileResponse.Id,
                'orgId': orgId,
                'techCode': getProfileResponse.Tech_Code ? getProfileResponse.Tech_Code : "null",
                'tech': isAdmin ? getProfileResponse?.Role?.Role === "tech" : getEmailAndRoleStatus?.Technician,
                'role': role,
                'organization':organization,
                'bio': getProfileResponse.Profile_Bio,
                'Provider_Service': 'Provider_Service' in getProfileResponse ? getProfileResponse.Provider_Service : [],
                'radius': getProfileResponse.Radius,
                'skillExp': getProfileResponse.Skills_Experience,
                'Stripe_Connect_Id': getProfileResponse.Stripe_Connect_Id,
                'Drive_URL': getProfileResponse.Drive_URL,
                'Referral_Link': getProfileResponse.Referral_Link,
                'Primary_Facility': getProfileResponse.Primary_Facility,
                'touch': touchPoint,
                'verified': isAdmin ? true : getEmailAndRoleStatus.Email_Verified,
                'email_verification_banner': isAdmin ? true : getEmailAndRoleStatus.Email_Verified,
                'profileUrl': getProfileResponse.Profile_URL

            };
            let currentUrl = window.location.href;
            if (currentUrl.includes("acceptance") == false) {
                if (techProfile['Stripe_Connect_Id'] == null || techProfile['Stripe_Connect_Id'] == "null") {
                    let stripeConnect = await ApiBaseHelper.post({
                        url: "stripe/connect-account",
                        payload: {
                            "id": techProfile['id'],
                            "email": techProfile['email'],
                            "first_name": techProfile['firstname'],
                            "last_name": techProfile['lastname'],
                            "phone_number": techProfile['phone'] ? techProfile['phone'] : '',
                            "address": techProfile['Primary_Facility'] ? techProfile['Primary_Facility']['Address'] : '',
                            "city": techProfile['Primary_Facility'] ? techProfile['Primary_Facility']['City'] : '',
                            "state": techProfile['Primary_Facility'] ? techProfile['Primary_Facility']['State'] : '',
                            "zip": techProfile['Primary_Facility'] ? techProfile['Primary_Facility']['zip code'] : '',
                            "token": token
                        },
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    });
                    techProfile['Stripe_Connect_URL'] = stripeConnect.data.data;
                } else {
                    let stripeConnect = await ApiBaseHelper.get({
                        url: "stripe/login-link/" + techProfile['Stripe_Connect_Id'],
                        headers: {
                            Authorization: 'Bearer ' + token
                        }
                    });
                    techProfile['Stripe_Connect_URL'] = stripeConnect.data.data.url;
                }
            }

            dispatch(updateTech(techProfile))
            dispatch(updateUser(null));
            // reserve tech profile details in order to restore the details to original state during team switches
            dispatch(updateTechReserve(techProfile))
        } else {
            dispatch(updateUser({
                "firstname": name[0].charAt(0).toUpperCase() + name[0].slice(1),
                "lastname": name[1].charAt(0).toUpperCase() + name[1].slice(1),
                "phone": getProfileResponse.Personal_Phone,
                "imageUrl": getProfileResponse.imgUrl,
                "email": getProfileResponse.Email_Address,
                'Provider_Service': 'Provider_Service' in getProfileResponse ? getProfileResponse.Provider_Service : [],
                'token': token,
                'id': getProfileResponse.Id,
                'orgId': orgId,
                'tech': isAdmin ? getProfileResponse?.Role?.Role === "tech" : getEmailAndRoleStatus?.Technician,
                'touch': touchPoint,
                'Referral_Link': getProfileResponse.Referral_Link,
                'Primary_Facility': getProfileResponse.Primary_Facility,
                'verified': isAdmin ? true : getEmailAndRoleStatus.Email_Verified,
                'email_verification_banner': isAdmin ? true : getEmailAndRoleStatus.Email_Verified,
                'role': role,
                'organization': organization,
                'profileUrl': getProfileResponse.Profile_URL,
                'pendingTech': validateTech.data?.data[0]?.Status.toLowerCase() === 'pending review', // a user with a pending tech application
                'new_signup': newSignup
            }))
            dispatch(updateTech(null));
        }

        // await FirebaseHelper.login();

        if (isSendVerificationEmail) {
            await sendVerificationEmail({
                email: getProfileResponse.Email_Address,
                userId: getProfileResponse.Id,
                sendNotification: false,
                token
            })
        }

        if (emailVerification == false) {
            setTimeout(function () {
                if (redirect)
                    window.open(getHomePageURL(orgId), redirectTarget);
                else
                    window.location.href = window.location.href;
            }, 1000)
        }
    
    } catch (e) {
        console.log("error in fetching profile data")
        notification['error']({
            message: 'Error',
            description:
                'Having problem in fetching profile data, please try again later.',
        });
    }

}

export async function sendVerificationEmail({email, userId, token, sendNotification = true}) {
    let code = Math.floor(100000 + Math.random() * 900000);
    let encryptedCode = encryptString(JSON.stringify({
        code,
        token,
        userId,
        email,
        expires: moment().add(1, "days").utc(false)
    }))

    // console.log("encryptedCode", encode(encryptedCode, {mode: 'extensive'}))

    // save it in database
    // FirestoreHelper.saveEmailVerificationCode(
    //     {
    //         code,
    //         user_id: userId
    //     }
    // )

    // send email to user
    await ApiBaseHelper.post({
        url: `web/send-verify-email`,
        payload: {
            param: encryptedCode,
            email
        },
        headers: {
            Authorization: 'Bearer ' + token,
        },
    });

    if (sendNotification) {
        Modal.info({
            title: "Verification link sent",
            content: <span>
                A link to verify your account has been sent to <Typography.Text strong>{email}</Typography.Text>. If you don't see the email in your main inbox, make sure to check your spam or junk folders.
            </span>,
        });
    }

}

export async function adminLogout({dispatch, notificationText = "You are logged out", history}) {
    notification.open({
        message: 'TecMe',
        description: notificationText
    });
    dispatch(updateTech(null));
    dispatch(updateUser(null));
    dispatch(updateAdmin(null));
    history.push(ROUTES.ADMIN_LOGIN);
}

export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function convertDeliverables(data, filter) {
    let response = data.split('\n');
    if (isJson(data)) {
        response = JSON.parse(data);
        response = response[filter] != undefined ? response[filter] : []
    } else {
        if (filter == 'red_cross_mark')
            response = [];
    }
    return response
}

export function isDevEnv() {
    let url = window.location.href;
    return (url.includes("localhost")
        || url.includes("development")
        || url.includes("staging")
        || url.includes("acceptance"));

}

export function getHomePageURL(orgId) {
    return ROUTES.DASHBOARD.replace(":org_id", orgId);
}

export const normalFile = (e) => {
    if (Array.isArray(e)) {
        return e;
    }
    return e && e.fileList;
}

export const contactSupportModal = (role, cancel = false) => {
    let content = "";
    if (cancel) {
        content = role == 'tech' ? "To cancel this service please call the TecMe support line and explain the situation to a support specialist. This is so we can maintain the highest customer satisfaction possible through the service cancellation"
            : "Please call the TecMe support line to report your technician. We will also ensure no fees are charged for the cancellation of this booking. Phone number: (888) 678-3263";
    } else
        content = <div>
            To contact support representative:
            <ul>
                <li>Email — support@tecme.io</li>
                <li>Call: (888) 678-3263</li>
                <li>Submit a ticket from the website</li>
            </ul>
        </div>
    return Modal.info({
        title: "Contact Support",
        content,
        centered: true,
    });
}

export function restrictUserForCreatingBookingModal({user_id, email, role = "customer", token}) {
    Modal.info({
        title: "Your account is not verified.",
        content:
            role == 'customer' ?
                'Please verify your email address first to create booking. Check your inbox and click on verify link.' :
                'Please verify your email address first to accept service request. Check your inbox and click on verify link.'
    });

    sendVerificationEmail({
        email,
        userId: user_id,
        sendNotification: false,
        token
    });
}

export const convertCentsIntoDollarsString = (cents) => (cents / 100).toFixed(0)

export const compressHipaaImages = ({url, height = 100, width = 100}) => {

    if (!url.includes('hipaa'))
        return url;
    let bucket = 'hipaadev';
    if (BASE_URL === STAGING_SERVER || BASE_URL === LOCAL_SERVER)
        bucket = 'hipaastaging';
    else if (BASE_URL === ACCEPTANCE_SERVER || BASE_URL === PROD_SERVER)
        bucket = 'hipaadoc';

    let jsonParams = {
        bucket,
        key: `uploaded${url.split('uploaded')[1]}`,
        edits: {
            resize: {
                height,
                width,
                fit: "cover"
            }
        }
    };

    return `https://dn44b65i5fg54.cloudfront.net/${btoa(JSON.stringify(jsonParams))}`
}

export const getZipCodeFromGeocodeResponse = (response) => {
    if (!response.results?.length) return;
    let zipCodeIndex = 0;
    const addressComponentIndex = response.results.findIndex((result, i) => {
        return result.address_components.find((address_component, index) => {
                const check = address_component.types?.includes("postal_code")
                if (check) zipCodeIndex = index
                return check
            }
        )
    });

    return addressComponentIndex > -1 ? response.results[addressComponentIndex].address_components[zipCodeIndex].long_name : "";
};

export const capitalizeFirstLetter = string => !string ? "" : string?.replace(/\s+/g, ' ').charAt(0)?.toUpperCase() + string?.replace(/\s+/g, ' ')?.slice(1)

export const getSpecificYears = (length) => {
    const year = new Date().getFullYear();

    return Array.from({length}, (_, i) => year - length + i + 1).sort((a,b) => a > b ? -1 : 0);
}


export const sortDates = (array) => !array.length ? ([]) : array.sort((a,b) => (moment(a.Start_Date || a["Start Date"]).isSameOrAfter(b.Start_Date || b["Start Date"]) ? -1 : 0))

export const capitalizeFirstWordOfEveryLetter = string => !string ? "" : string?.replace(/\s+/g, ' ')?.split(" ").map((name) => `${name[0]?.toUpperCase()}${name?.slice(1)}`)?.join(" ")


// For Small Data Set
// export const mapCityStateWithCount = async (activeUser) => {
//     const result = []
//     for (let i = 0; i < STATES.length; i++) {
//         const state = STATES[i];
//         const citiesList = citiesStatesWithLngLatMin.filter((item) => state.State.toLowerCase() === item.state.toLowerCase());

//         if(citiesList?.length) {
//             for (let index = 0; index < citiesList.length; index++) {
//                 const city = citiesList[index];
//                 const res = await ApiBaseHelper.get({
//                     url: `technician?latitude=${city.latitude}&longitude=${city.longitude}&bookingType=home`,
//                     // url: `web/technicians?latitude=${city.latitude}&longitude=${city.longitude}&bookingType=home`,
//                     headers: {
//                         'Authorization': `Bearer ${activeUser.token}`
//                     }
//                 })
                
//                 if(res.data?.data?.length && res.data.data.filter(({ data }) => data.imgUrl && data.imgUrl !== 'TO BE IMPLEMENTED IN MIDDLEWARE').length >= MINIMUM_NUMBER_OF_TECHS) {
//                     result.push({
//                         stateCode: state.Code,
//                         state: state.State,
//                         city: city.city,
//                         longitude: city.longitude,
//                         latitude: city.latitude,
//                         count: res.data.data.length
//                     })        
//                 }
//             }
//         }
//     }

//     console.log({ result })
// }

// For Large Data Set
// export const mapCityStateWithCount = async (activeUser) => {
//     const result = []
//     for (let i = 0; i < STATES.length; i++) {
//         const state = STATES[i];
//         const citiesList = citiesStatesWithLngLat.filter(({ STATE_CODE }) => state.Code === STATE_CODE);
//         if(citiesList?.length) {
//             for (let index = 0; index < citiesList.length; index++) {
//                 const city = citiesList[index];
//                 const res = await ApiBaseHelper.get({
//                     url: `technician?latitude=${city.LATITUDE}&longitude=${city.LONGITUDE}&bookingType=home`,
//                     // url: `web/technicians?latitude=${city.LATITUDE}&longitude=${city.LONGITUDE}&bookingType=home`,
//                     headers: {
//                         'Authorization': `Bearer ${activeUser.token}`
//                     }
//                 })
                
//                 if(res.data?.data?.length && res.data.data.filter(({ data }) => data.imgUrl && data.imgUrl !== 'TO BE IMPLEMENTED IN MIDDLEWARE').length >= MINIMUM_NUMBER_OF_TECHS) {
//                     result.push({
//                         stateCode: state.Code,
//                         state: state.State,
//                         city: city.CITY,
//                         longitude: city.LONGITUDE,
//                         latitude: city.LATITUDE,
//                         count: res.data.data.length
//                     })        
//                 }
//             }
//         }
//     }

//     console.log({ result })
// }

export const getStatesWhereTechExists = () => {
    const filteredStates = []
    MATCHED_CITIES_STATES.forEach(item => {
        if(!filteredStates.length) filteredStates.push(item)
        if(filteredStates.every(s => s.stateCode !== item.stateCode)) filteredStates.push(item)
    })

    return filteredStates
}

export const getCitiesWhereTechExists = (state) => !state ? [] : MATCHED_CITIES_STATES.filter(item => item.state.toLowerCase() === state.toLowerCase())

export const getSelectedCityWhereTechExists = (state, city) => (!state || !city) ? ({}) : MATCHED_CITIES_STATES.find(item => item.state.toLowerCase() === state.toLowerCase() && item.city.toLowerCase() === city.toLowerCase())

export const convertToLocalTime = (timeStamp) => {
    return moment(moment.utc(timeStamp).toDate()).local()
}

export const getLocalTimeFormat = (timeStamp) => {
    const localTimestamp = moment(moment.utc(timeStamp).toDate()).local()
    return localTimestamp.format("MMM Do YYYY") + ' | ' + localTimestamp.format("ddd") + ' | ' + localTimestamp.format("h:mm a")
}

export const getTableTimeFormat = (timeStamp) => {
    const localTimestamp = moment(moment.utc(timeStamp).toDate()).local()
    return localTimestamp.format("MMM Do YYYY") + ', ' + localTimestamp.format("h:mm a")
}

export const getDottedTimeFormat = (timeStamp) => {
    const localTimestamp = moment(moment.utc(timeStamp).toDate()).local()
    return localTimestamp.format("DD") + ' ' + localTimestamp.format("MMMM") + ', ' + localTimestamp.format("YYYY")
}

export const getFromNowDateFormat = (timeStamp) => {
    const localTimestamp = moment(moment.utc(timeStamp).toDate()).local()
    return localTimestamp.fromNow()
}

export const truncateText = (text, maxNum) => {
    return text?.length <  maxNum ? text : `${text.slice(0,  maxNum)}...`
}

export const callPostApiWithErrorHandling = async ({ url, payload }) => {
    try {
        return await ApiBaseHelper.post({ url, payload })
    } catch (error) {
        notification.error({
            message: 'TecMe',
            description: error?.response?.data?.message || 'Something went wrong, please try again later.'
        });
    }
}

export const filterWeeklyTimeSheet = (timeSheetData = []) => {
    const newFilteredTimeSheetData = timeSheetData.filter(data => {
        const currentDate = moment();
        const clockInDate = moment(data.Clock_In_Date_Time);
        const clockOutDate = moment(data.Clock_Out_Date_Time);

        const currentWeek = currentDate.week();
        const clockInWeek = clockInDate.week();
        const clockOutWeek = clockOutDate.week();

        if (currentWeek === clockInWeek && currentWeek === clockOutWeek) {
            return true
        }

        return false
    })

    return newFilteredTimeSheetData
}
export const getMarketingWebsiteURL = () => {
    let URL = 'https://tecme.io';
    // if (BASE_URL === DEV_SERVER)
    //     URL = 'https://website.tecme.io';
    // if (BASE_URL === STAGING_SERVER)
    //     URL = 'https://website.tecme.io';
    // else if (BASE_URL === ACCEPTANCE_SERVER || BASE_URL === PROD_SERVER)
    //     URL = 'https://tecme.io';
    return URL;
}

export const getSpecializationExample = (specialization) => {
    let example = [];
    switch (specialization) {
        case 'business software':
            example = ["Accounting software", "Customer Relationship Management (CRM) software", "Enterprise Resource Planning (ERP) software", "Human Resources Management (HRM) software", "Project Management software", "Business Intelligence (BI) software", "Sales Force Automation (SFA) software", "Marketing Automation software", "Inventory Management software", "Point of Sale (POS) software"]
            ;
            break;
        case 'enterprise resource planning (erp)':
            example = ["SAP", "Oracle ERP Cloud", "Microsoft Dynamics 365", "NetSuite", "Epicor ERP", "Infor ERP", "Acumatica Cloud ERP", "Sage Intacct", "Syspro ERP", "IFS Applications"]
            ;
            break;
        case 'customer relationship management (crm)':
            example = ["Salesforce", "HubSpot CRM", "Microsoft Dynamics 365", "Zoho CRM",    "SugarCRM", "Pipedrive", "Freshworks CRM", "Insightly", "Agile CRM", "Copper"]
            ;
            break;
        case 'telecommunications':
            example = ["Mobile network optimization", "IP network design and optimization",    "Network function virtualization (NFV)", "Software-defined networking (SDN)", "Fiber optic network design and implementation", "Wireless network design and optimization",    "Telecom expense management (TEM)", "Unified communications and collaboration (UC&C)",    "Network security and risk management", "IoT and M2M solutions"]
            ;
            break;
        case 'it management':
            example = ['Microsoft System Center', 'SolarWinds', 'ManageEngine', 'BMC Remedy', 'Ivanti'];
            break;
        case 'cybersecurity':
            example = ["Network security", "Endpoint security", "Cloud security", "Data loss prevention (DLP)", "Identity and access management (IAM)", "Application security",    "Penetration testing and vulnerability assessment", "Security information and event management (SIEM)", "Security assessment and compliance", "Cybersecurity risk management"]
            ;
            break;
        case 'windows operating systems':
            example = ["Windows Server Administration", "Windows Networking", "Windows Active Directory", "Windows Security", "Windows PowerShell Scripting", "Windows Deployment", "Windows Performance Tuning", "Windows Troubleshooting", "Windows Virtualization", "Windows Remote Desktop Services (RDS)"]
            ;
            break;
        case 'virtual machines':
            example = ["VMware vSphere", "Microsoft Hyper-V", "Citrix Hypervisor (formerly XenServer)", "Oracle VM VirtualBox", "Red Hat Virtualization", "Proxmox Virtual Environment", "KVM (Kernel-based Virtual Machine)", "Xen Project", "Docker", "Vagrant"]
            ;
            break;
        case 'operating systems and virtualization':
            example = ["Windows Server Administration", "Linux Server Administration", "VMware vSphere", "Microsoft Hyper-V", "Citrix Hypervisor (formerly XenServer)", "Oracle VM VirtualBox", "Red Hat Virtualization", "Proxmox Virtual Environment", "KVM (Kernel-based Virtual Machine)", "Xen Project"]
            ;
            break;
        case 'computer hardware':
            example = ["PC assembly and repair", "Hardware troubleshooting and maintenance", "Printers and peripherals installation and configuration", "Network hardware installation and configuration", "Server hardware installation and configuration", "Storage hardware installation and configuration", "Embedded systems design and development", "Microcontroller programming and development", "ASIC design and development", "FPGA design and development"]
            ;
            break;
        case 'wireless networking':
            example = ["Wireless network design and optimization", "Wi-Fi network installation and configuration", "Wireless security", "Mobile device management (MDM)", "Mobile application management (MAM)", "Location-based services", "Wireless site surveys", "Wireless troubleshooting", "Mobile data analytics", "Bluetooth and NFC technologies"]
            ;
            break;
        case 'hardware and networking':
            example = ["PC assembly and repair", "Hardware troubleshooting and maintenance", "Printers and peripherals installation and configuration", "Network hardware installation and configuration", "Wireless network design and optimization", "Server hardware installation and configuration", "Storage hardware installation and configuration", "Network security and risk management", "Unified communications and collaboration (UC&C)", "Virtualization and cloud computing"]
            ;
            break;
        case 'technical troubleshooting':
            example = ["Hardware troubleshooting", "Software troubleshooting", "Network troubleshooting", "Operating system troubleshooting", "Application troubleshooting", "Mobile device troubleshooting", "Printer troubleshooting", "Server troubleshooting", "Cloud service troubleshooting", "Security troubleshooting"]
            ;
            break;
        case 'on-site it support':
            example = ["Hardware installation and configuration", "Software installation and configuration", "Network installation and configuration", "Printer and peripheral installation and configuration", "Mobile device setup and configuration", "Remote access and VPN setup", "User training and education", "Hardware and software maintenance", "Data backup and recovery", "Security and antivirus setup"]
            ;
            break;
        case 'remote it support':
            example = ["Help desk support", "Technical support", "Software troubleshooting", "Remote desktop support", "Email and messaging support", "Mobile device support", "Cloud service support", "Security and antivirus support", "Data backup and recovery support", "Remote access and VPN support"]
            ;
            break;
        case 'data management and storage':
            example = ["Database administration", "Data analysis and reporting", "Data modeling and architecture", "Big data management and analysis", "Data warehousing", "Cloud storage and management", "Backup and disaster recovery", "Data security and privacy", "Data governance and compliance", "Data integration and migration"]
            ;
            break;
        case 'data warehousing':
            example = ["Data modeling and architecture", "ETL (extract, transform, load) design and implementation", "Data quality and cleansing", "Metadata management", "Data governance and compliance", "Business intelligence and analytics", "Data warehouse optimization and performance tuning", "Master data management", "Data migration and integration", "Data warehouse automation"]
            ;
            break;
        case 'data archiving':
            example = ["Data classification and retention policies", "Data backup and recovery", "Data compression and deduplication", "Data encryption and security", "Long-term data storage planning and management", "Data migration and consolidation", "Data retrieval and access management", "Data disposal and destruction", "Legal and regulatory compliance", "Cloud-based archiving solutions"]
            ;
            break;
        default:
            example = [];
            break;
    }
    return example;
}

// Check if user can read page only according to their roles
export const canReadPageOnly = (role) => {
    const pathname = window.location.pathname;
    if(role?.toLowerCase() === "recruiter" && RecruiterRouteBlacklist.some((route) => pathname.includes(route))){
        return true
    } else if(role?.toLowerCase() === "manager" && ManagerRouteBlacklist.some((route) => pathname.includes(route))){
        return true
    }else{
        return false
    }
}

export const isAdministrator = (role) => {   
    if(role?.toLowerCase() === "administrator"){
        return true
    }else{
        return false
    }
}


export function getCreditCardInfo(cardNumber) {
    // Remove all non-digit characters from the card number
    const cleanedCardNumber = cardNumber.replace(/\D/g, '');

    // Get the first 6 digits of the card number
    const firstSixDigits = cleanedCardNumber.slice(0, 6);
  
    // Define regular expressions to match different credit card types
    const cardRegexes = [
      { regex: /^4[0-9]{5}/, name: 'Visa', logo: VisaSvg },
      { regex: /^5[1-5][0-9]{4}/, name: 'Mastercard', logo: MasterCardSvg },
      { regex: /^3[47][0-9]{4}/, name: 'American Express', logo: AmericanExpressSvg  },
      { regex: /^(?:2131|1800|35\d{2})\d{3}/, name: 'JCB', logo: JcbSvg },
      { regex: /^6(?:011|5[0-9]{2})[0-9]{3}/, name: 'Discover', logo: DiscoverSvg },
      { regex: /^3(?:0[0-5]|[68][0-9])[0-9]{3}/, name: 'Diners Club', logo: DinersClubSvg }
    ];
  
    // Find the matching card type
    const matchedCard = cardRegexes.find(card => card.regex.test(firstSixDigits));
  
    // Return the card name or 'Unknown' if no match was found
    return matchedCard ? matchedCard : null;
  }

// Add a subdomain to the current URL

export function addSubdomainToBaseUrl(subdomainToAdd) {
    const url = new URL(window.location.href);
    // Extract the full domain (including subdomains if any)
    let fullDomain = url.hostname;
    
    // Check if the domain already has a subdomain
    const parts = fullDomain.split('.');
    
    if (parts.length > 2 && parts[0] !== 'app') {
        fullDomain = subdomainToAdd + '.' + fullDomain;
      } else if(parts.length > 2 && parts[0] === 'app'){
          fullDomain = fullDomain.replace("app", subdomainToAdd)
      } else {
        // For second-level domains (e.g., example.io), just add the subdomain before the domain
        parts.splice(0, 0, subdomainToAdd);
        fullDomain = parts.join('.');
      }
  
    // Construct the new URL with the updated domain
    const newUrl = `${url.protocol}//${fullDomain}`;
  
    // Return the modified URL without any path, query, or fragment
    return newUrl;
}

export function removeSubdomainFromUrl(subdomainToRemove, originalSubdomain = 'app') {
    const url = new URL(window.location.href);
    let parts = url.hostname.split('.');
    
    // If the first part of the hostname matches the subdomain to remove, remove it
    if (parts[0] === subdomainToRemove) {
        parts.shift(); // Remove the first part
        if(parts.length == 2){
            parts.unshift(originalSubdomain)
        }
    }
    
    const newHostname = parts.join('.');
    const newUrl = `${url.protocol}//${newHostname}${url.port ? ':' + url.port : ''}`;
  
    return newUrl;
}

  // check for light color and convert to darker shade
function hexToRGB(hex) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    }
    // 6 digits
    else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }
    return [r, g, b];
}

function luminance(r, g, b) {
    const a = [r, g, b].map(function(v) {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function darkenHex(hex, amount=0.7) {
    const [r, g, b] = hexToRGB(hex);
    return "#" + [r, g, b].map(x => {
        const darker = Math.floor(x * amount).toString(16);
        return darker.length === 1 ? "0" + darker : darker;
    }).join("");
}

export const convertIfLight = (hex) => {
    const [r, g, b] = hexToRGB(hex);
    if (luminance(r, g, b) > 0.5) { // Assuming luminance threshold of 0.5 to consider it light
        return darkenHex(hex); // Darken if light
    }
    return hex; // Return original if not light
}

// check if string is a valid url
export const isValidUrl = (string) => {
    const pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$','i' // fragment locator
    );
    return !!pattern.test(string);
}

// check if iframe is valid
export function isValidIframe(iframeString) {
    const iframeRegex = /<iframe\s+[^>]*src=["']([^"']+)["'][^>]*><\/iframe>/i;
    return iframeRegex.test(iframeString);
}

// remove html tags from string
export function stripHtml(htmlString) {
    // Use a regular expression to remove HTML tags
    const cleanText = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
    return cleanText;
  }

// Firebase conversations helper

// Function to get and set group conversations.
export const getAndSetGroupCoversation = async (groupName) => {
    await FirebaseHelper.login();
    const participantsResponse = await FirestoreHelper.getAllGroupConversations();
    const groupConversations = [];
    participantsResponse.forEach((doc) => {
      let item = doc.data();
      item.id = doc.id;
      if (item.group && item.participants?.length) {
        groupConversations.push({ ...item});
      }
    });
    console.log(groupConversations.find((c) => c.group.toLowerCase() === (groupName?.toLowerCase())))
    return (groupConversations.find((c) => c.group.toLowerCase() === (groupName?.toLowerCase())))
}

// Function to create group chat
export const createGroupChat = async (groupName, tech) => {  
    const rtmRepository = new RtmRepository(tech?.token);
    const techName = `${tech?.firstname} ${tech?.lastname}`;
    let group = ucwords(groupName);
    
    await FirebaseHelper.login();
    
    return rtmRepository.createGroupConversation([tech?.id])
        .then(async (response) => {
            let conversationId = response.data.data.id;
            
            await FirestoreHelper.createUser({
                hipaa_id: tech?.id,
                display_name: techName,
                profile_picture: tech?.imageUrl,
                role: "Technician",
            });
            
            let message = `${group} group chat created by ${techName} to manage company conversations`;

            await FirestoreHelper.createConversation({
                conversation_id: conversationId,
                message: encryptString(message),
                participants: [tech?.id],
                user_id: tech?.id,
                group,
            });

            return FirestoreHelper.sendMessage({
                conversation_id: conversationId,
                message: encryptString(message),
                user_id: tech?.id,
            });
        });
};

// Function to check project link and return name and logo
export function addProjectManagementLinkLogo(projectLink, returnType = "both") {
    if (typeof projectLink !== "string") {
        console.log(typeof projectLink)
        console.error("Invalid project link:", projectLink);
        return returnType === "logo" ? null : { name: "Unknown", logo: null };
    }
    const platforms = [
        {
            name: "Jira",
            regex: /^(https?:\/\/)?(www\.)?(jira\.com|[a-zA-Z0-9-]+\.atlassian\.net)(?:\/(?:jira\/software\/projects\/|browse\/|projects\/|board\/|issue\/|jira\/projects\/)?([A-Z]+-\d*|[a-zA-Z0-9-]+))?(?:\/boards\/\d+)?(?:\?.*)?$/,
            logo: JiraIcon,
        },
        {
            name: "Asana",
            regex: /https?:\/\/(?:app\.)?asana\.com\/[^\s]+/g,
            logo: AsanaIcon,
        },
        {
            name: "Trello",
            regex: /https?:\/\/(?:www\.)?trello\.com\/[^\s]+/g,
            logo: TrelloIcon,
        },
        {
            name: "ClickUp",
            regex: /https?:\/\/(?:www\.)?clickup\.com\/[^\s]+/g,
            logo: ClickupIcon,
        },
        {
            name: "Notion",
            regex: /https?:\/\/(?:www\.)?notion\.so\/[^\s]+/g,
            logo: NotionIcon,
        },
    ];

    for (const platform of platforms) {
        if (platform.regex.test(projectLink)) {
            if (returnType === "name") return platform.name;
            if (returnType === "logo") return platform.logo;
            return { name: platform.name, logo: platform.logo };
        }
    }

    const subdomainMatch = projectLink && projectLink.match(/https?:\/\/(?:www\.)?([^\.\/]+)\./);;
    const subdomain = subdomainMatch ? subdomainMatch[1] : "Unknown";
    const genericLogo = null;

    if (returnType === "name") return subdomain;
    if (returnType === "logo") return genericLogo;

    return { name: subdomain, logo: genericLogo };
}

// get src from iframe
export function getIframeSrc(iframe) {
    const src = iframe?.match(/src=["']([^"']*)["']/);
    return src ? src[1] : "";
}

// clean iframe content
export function cleanIframeContent(html) {
    return html.replace(/(<iframe\b[^>]*>)(.*?)(<\/iframe>)/gis, "$1$3");
}

export function repairMalformedServiceArray(str) {
    // First, ensure it starts and ends with square brackets
    if (!str.startsWith("[") || !str.endsWith("]")) return null;
  
    // Extract the content inside the brackets
    const inner = str.slice(1, -1);
  
    // Use a regex that matches either single-quoted or double-quoted strings
    const regex = /(['"])(.*?)\1/g;
    const matches = [];
    let match;
  
    while ((match = regex.exec(inner)) !== null) {
      matches.push(match[2]); // push the inner text only
    }
  
    return matches;
}

  export const DEVICE_BRANDS = [
    "Apple",
    "Samsung",
    "HP",
    "Dell",
    "Lenovo",
    "Asus",
    "Microsoft",
    "Sony",
    "LG",
    "Xiaomi",
    "Huawei",
    "Google",
    "Motorola",
    "Nokia",
    "OnePlus",
    "Oppo",
    "Vivo",
    "Acer",
    "Toshiba",
    "Panasonic",
    "GoPro",
    "DJI",
    "Fitbit",
    "Garmin",
    "Bose",
    "JBL",
    "Sonos",
    "Amazon (for Amazon Echo devices)",
    "Ring",
    "Nest (for Nest smart home devices)",
    "Philips Hue (for smart lighting)",
    "Ecobee",
    "August (for smart locks)",
    "Arlo (for smart security cameras)",
    "iRobot (for robot vacuum cleaners)",
    "Anker",
    "Belkin",
    "TP-Link",
    "Logitech",
    "Razer",
    "Canon",
    "Nikon",
    "Fujifilm",
    "GoPro",
    "HTC",
    "Blackberry",
    "Microsoft Surface",
    "Wacom",
    "Adobe",
    "Western Digital",
  ]
  
